/* 虛擬展場 3D 互動品牌展間（移植自 riease-web-v2 assets/js/threejs.js @14cc4b8）
   七章節導覽、RURU 機器人對話、進場動畫、章節熱點。
   改用首頁同一組全域 three r128 + examples/js 載入器，不使用 ES module。 */

const canvas = document.querySelector('.space-3d')
const exhibitionRoot = document.querySelector('.three-js')
const isStandalone = Boolean(exhibitionRoot?.closest('.virtual-exhibition-page'))
const isHomeExperience = exhibitionRoot?.classList.contains('exhibition-shell-home')
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
const mobileExhibitionBreakpoint = 820

if (!canvas || !exhibitionRoot) {
    throw new Error('Virtual exhibition canvas is missing.')
}

const assetUrl = (relativePath) => relativePath
const modelSources = {
    exhibit: assetUrl('./glb/exhibit.glb'),
    robot: assetUrl('./glb/robot.glb')
}

const ui = {
    loader: document.getElementById('exhibitionLoader'),
    loaderActions: document.getElementById('loaderActions'),
    enter: document.getElementById('enterExhibition'),
    progressBar: document.getElementById('exhibitionProgressBar'),
    progressText: document.getElementById('exhibitionProgressText'),
    retry: document.getElementById('exhibitionRetry'),
    status: document.getElementById('exhibitionStatus'),
    statusText: document.querySelector('.exhibition-status-text'),
    guide: document.getElementById('controlGuide'),
    closeGuide: document.getElementById('closeGuide'),
    help: document.getElementById('helpButton'),
    reset: document.getElementById('resetViewButton'),
    fullscreen: document.getElementById('fullscreenButton'),
    storyPanel: document.getElementById('storyPanel'),
    storyClose: document.getElementById('storyClose'),
    storyHandle: document.getElementById('storyHandle'),
    storyIndex: document.getElementById('storyIndex'),
    storyKicker: document.getElementById('storyKicker'),
    storyTitle: document.getElementById('storyTitle'),
    storyLead: document.getElementById('storyLead'),
    storyBody: document.getElementById('storyBody'),
    chapterRail: document.getElementById('chapterRail'),
    previousChapter: document.getElementById('previousChapter'),
    nextChapter: document.getElementById('nextChapter'),
    chapterProgress: document.getElementById('chapterProgress'),
    chapterButtons: [...document.querySelectorAll('[data-chapter].chapter-rail-item')],
    hotspots: [...document.querySelectorAll('[data-chapter].world-hotspot')],
    robotDialogue: document.getElementById('robotDialogue'),
    robotMode: document.querySelector('.robot-dialogue-copy > span'),
    robotSpeech: document.getElementById('robotSpeech'),
    guidedTour: document.getElementById('guidedTourButton'),
    robotFact: document.getElementById('robotFactButton'),
    movementButtons: [...document.querySelectorAll('[data-move].movement-button')],
    tourProgress: document.querySelector('#tourProgress span'),
    toast: document.getElementById('exhibitionToast'),
    tooltip: document.querySelector('.exhibit-text')
}

const chapters = [
    {
        kicker: 'WELCOME TO RIEASE',
        title: '把複雜，交給睿鍶。',
        lead: '從一個需求開始，我們把資訊、流程與技術整理成真正能推動營運的數位體驗。',
        speech: '嗨，我是 RURU。這裡不是模型展示櫃，而是睿鍶如何把複雜變簡單的入口。',
        facts: [
            '你可以點擊空間中的發光節點，也可以讓我用七個章節帶你走一遍。',
            '拖曳可以轉動視角；如果迷路，右下角的「入口視角」會帶你回來。'
        ],
        body: `
            <div class="story-stat-grid">
                <div><strong>25+</strong><span>年業界經驗</span></div>
                <div><strong>1000+</strong><span>件案件作品</span></div>
                <div><strong>100%</strong><span>案件交付率</span></div>
            </div>
        `
    },
    {
        kicker: 'WHO WE ARE',
        title: '長期陪企業把想法變成可運作的系統。',
        lead: '睿鍶科技成立於 2009 年，總部位於桃園，專注客製化軟體解決方案與企業數位轉型。',
        speech: '睿鍶不只交付畫面。我們從市場洞察、流程理解到技術落地，陪客戶把改變真正放進日常營運。',
        facts: [
            '我們相信好的系統不是功能越多越好，而是每個功能都解決一個真實問題。',
            '賦能企業、化繁為簡、智創未來，是我們做每個專案時的三個判斷基準。'
        ],
        body: `
            <div class="story-pill-row">
                <span>01 賦能企業</span><span>02 化繁為簡</span><span>03 智創未來</span>
            </div>
            <p class="story-note">融合先進技術與專業服務，協助企業建立智慧、安全、互聯的商業未來。</p>
        `
    },
    {
        kicker: 'SIX CAPABILITIES',
        title: '六種能力，串成一條完整的數位路徑。',
        lead: '從品牌入口到核心系統，再到跨平台資料流與長期維運，睿鍶用同一個團隊承接完整生命週期。',
        speech: '你不必先決定要買哪一套技術。先告訴我們卡住的流程，我們會從需求反推最合適的解法。',
        facts: [
            '網站製作與系統開發負責體驗入口，智能助理與數據洞察則讓 AI 接手重複工作、回答數字問題。',
            '導入不是一次改版；資安防護與系統維運讓成果可以安全、穩定地走得更久。'
        ],
        body: `
            <div class="service-grid">
                <div><span>01</span><strong>網站製作</strong><small>品牌架構與易用介面</small></div>
                <div><span>02</span><strong>系統開發</strong><small>貼合情境的客製平台</small></div>
                <div><span>03</span><strong>智能助理</strong><small>AI 客服應答與文件草擬</small></div>
                <div><span>04</span><strong>數據洞察</strong><small>報表自動化與 AI 問答</small></div>
                <div><span>05</span><strong>資安防護</strong><small>安全控管與風險治理</small></div>
                <div><span>06</span><strong>系統維運</strong><small>持續監控與技術支援</small></div>
            </div>
        `
    },
    {
        kicker: 'AI IN YOUR WORKFLOW',
        title: 'AI 不另起一套，而是接進現在的工作流程。',
        lead: '從客服、文件、跨系統資料流到經營報表，睿鍶把 AI 放進既有 ERP、POS 與 LINE，讓 AI 先做、人工把關。',
        speech: 'AI 展區展示四個能直接落地的場景。重點不是換掉現有系統，而是讓重複工作先被 AI 接住。',
        facts: [
            'LINE 智能客服與文件 AI 助理會在不確定時轉交真人，避免 AI 自行承諾或填寫關鍵資料。',
            '流程自動化與 AI 報表會保留人工確認、錯誤佇列與指標定義，讓效率提升仍然可控。'
        ],
        body: `
            <div class="service-grid ai-module-grid">
                <div><span>01</span><strong>LINE 智能客服</strong><small>FAQ 先答，沒把握就轉真人</small></div>
                <div><span>02</span><strong>文件 AI 助理</strong><small>摘要與草擬交給 AI，決策留給人</small></div>
                <div><span>03</span><strong>流程自動化</strong><small>串接 ERP／POS，減少人工搬資料</small></div>
                <div><span>04</span><strong>AI 報表洞察</strong><small>主動指出異常與趨勢，中文即可問數字</small></div>
            </div>
            <p class="story-note">AI 先做、人工把關 · 接進既有系統 · 固定範圍導入</p>
        `
    },
    {
        kicker: 'HOW WE DELIVER',
        title: '從需求到上線，每一步都能被看見。',
        lead: '用清楚的節點降低溝通成本，用反覆驗證讓產品在真正交付前就貼近使用者與營運目標。',
        speech: '專案最怕黑盒子。RURU 幫你把流程攤開：每個階段都有輸入、產出與可以一起確認的決策。',
        facts: [
            '需求梳理與架構規劃先校準方向，UI／UX 原型則讓抽象想法提早變得可討論。',
            '開發不是最後一步；測試、資安檢核、上線交付與持續維運才構成完整閉環。'
        ],
        body: `
            <ol class="process-track">
                <li><span>01</span><strong>需求洞察</strong></li>
                <li><span>02</span><strong>架構規劃</strong></li>
                <li><span>03</span><strong>體驗設計</strong></li>
                <li><span>04</span><strong>敏捷開發</strong></li>
                <li><span>05</span><strong>測試檢驗</strong></li>
                <li><span>06</span><strong>交付維運</strong></li>
            </ol>
        `
    },
    {
        kicker: 'TRUST BY DESIGN',
        title: '交付是承諾，資安是底線。',
        lead: '通過 ISO 27001 資安認證，並以跨公部門、教育、金融與產業的實績，累積長期合作的信任。',
        speech: '看得見的介面只是一小部分。權限、資料、稽核與穩定性，才是企業系統能不能放心使用的關鍵。',
        facts: [
            '服務對象橫跨教育部、僑務委員會、地方政府、研究機構、學校與金融產業。',
            'ISO 27001 不是牆上的標章，而是需求、開發、交付與維運都必須遵守的工作方法。'
        ],
        body: `
            <div class="trust-card">
                <div class="iso-mark"><span>ISO</span><strong>27001</strong></div>
                <p>資訊安全管理系統認證</p>
            </div>
            <div class="partner-cloud" aria-label="合作夥伴">
                <span>教育部</span><span>僑務委員會</span><span>桃園市政府</span><span>核能研究所</span>
                <span>國立中央大學</span><span>商業發展研究院</span><span>中國信託銀行</span>
            </div>
        `
    },
    {
        kicker: 'BUILD WHAT IS NEXT',
        title: '下一個改變，可以從一場對話開始。',
        lead: '無論是網站開發、系統客製、資訊安全或效能優化，睿鍶都會先理解問題，再一起定義最適合的前進方式。',
        speech: '旅程到這裡不是結束。把你的目標告訴我們，下一個展區，也許就是你的數位轉型故事。',
        facts: [
            '不知道該從哪一種服務開始也沒關係；描述目前的流程與困擾，就是最好的起點。',
            '你可以直接寄信到 service@riease.com，或前往官網留下需求。'
        ],
        body: `
            <div class="contact-card">
                <p>準備好打造你的專屬解決方案了嗎？</p>
                <a href="contact.html">與睿鍶聊聊 <span aria-hidden="true">↗</span></a>
                <div><a href="mailto:service@riease.com">service@riease.com</a><a href="tel:+88632129889">03-212-9889</a></div>
            </div>
        `
    }
]

const chapterViews = [
    { position: [0, 128, 460], target: [0, 98, 80] },
    { position: [-24, 128, 440], target: [-380, 100, 220] },
    { position: [-34, 128, 485], target: [-410, 100, 520] },
    { position: [-22, 130, 505], target: [-220, 102, 820] },
    { position: [22, 130, 505], target: [220, 102, 820] },
    { position: [34, 128, 485], target: [410, 100, 520] },
    { position: [24, 128, 440], target: [380, 100, 220] }
].map((view) => ({
    position: new THREE.Vector3(...view.position),
    target: new THREE.Vector3(...view.target)
}))

const chapterZoneData = [
    { index: '00', kicker: 'ENTRY SIGNAL', title: 'RIEASE', subtitle: '把複雜，化成清楚的下一步', accent: '#e8c98f' },
    { index: '01', kicker: 'WHO WE ARE', title: '2009 → NOW', subtitle: '從桃園出發的數位實作團隊', accent: '#d28a55' },
    { index: '02', kicker: 'SIX CAPABILITIES', title: 'ONE JOURNEY', subtitle: '六種能力，串成完整生命週期', accent: '#50c8ff' },
    { index: '03', kicker: 'AI IN WORKFLOW', title: 'HUMAN + AI', subtitle: 'AI 先做，人工把關，接進既有系統', accent: '#70e0b5' },
    { index: '04', kicker: 'VISIBLE PROCESS', title: '6 STEPS', subtitle: '從洞察到交付，每步都能被看見', accent: '#ff9b62' },
    { index: '05', kicker: 'TRUST BY DESIGN', title: 'ISO 27001', subtitle: '把資安與品質寫進每次交付', accent: '#7fa7e8' },
    { index: '06', kicker: 'BUILD WHAT IS NEXT', title: 'LET’S TALK', subtitle: '下一個改變，從一場對話開始', accent: '#e16fd8' }
]

const chapterThemes = [
    { accent: 0xe8c98f, light: 0xffedc7, css: '#e8c98f', soft: 'rgb(232 201 143 / 16%)' },
    { accent: 0xd28a55, light: 0xffc48f, css: '#d28a55', soft: 'rgb(210 138 85 / 16%)' },
    { accent: 0x50c8ff, light: 0xb8ebff, css: '#50c8ff', soft: 'rgb(80 200 255 / 16%)' },
    { accent: 0x70e0b5, light: 0xc8ffe9, css: '#70e0b5', soft: 'rgb(112 224 181 / 16%)' },
    { accent: 0xff9b62, light: 0xffd0ac, css: '#ff9b62', soft: 'rgb(255 155 98 / 16%)' },
    { accent: 0x7fa7e8, light: 0xc8dcff, css: '#7fa7e8', soft: 'rgb(127 167 232 / 16%)' },
    { accent: 0xe16fd8, light: 0xffc4fa, css: '#e16fd8', soft: 'rgb(225 111 216 / 16%)' }
]

const robotChapterPoses = [
    { position: [-128, 10, 62], action: 'welcome' },
    { position: [-252, 10, 94], action: 'point' },
    { position: [88, 10, 202], action: 'showcase' },
    { position: [168, 10, 292], action: 'ai' },
    { position: [-228, 10, 252], action: 'walk' },
    { position: [62, 10, 364], action: 'scan' },
    { position: [-112, 10, 150], action: 'celebrate' }
]

const robotActionLabels = {
    welcome: 'RURU · 迎賓模式',
    point: 'RURU · 品牌指引',
    showcase: 'RURU · 能力展示',
    ai: 'RURU · AI 協作模式',
    walk: 'RURU · 流程帶路',
    scan: 'RURU · 資安掃描',
    celebrate: 'RURU · 完成慶祝'
}

const hotspotAnchors = new Map([
    [1, new THREE.Vector3(-380, 176, 220)],
    [2, new THREE.Vector3(-410, 176, 520)],
    [3, new THREE.Vector3(-220, 176, 820)],
    [5, new THREE.Vector3(410, 176, 520)]
])

const loadingProgress = new Map(Object.keys(modelSources).map((key) => [key, 0]))
const loader = new THREE.GLTFLoader()
const dracoLoader = new THREE.DRACOLoader()
dracoLoader.setDecoderPath('./js/draco/')
loader.setDRACOLoader(dracoLoader)
const scene = new THREE.Scene()
let exhibit
let robot
let leftArm
let hiddenBones
let camera
let controls
let renderer
let screenMesh
let cameraTransition
let currentChapter = 0
let factCursor = 0
let guidedTourActive = false
let guidedTourTimer
let guidedTourRemaining = 0
let guidedTourStartedAt = 0
let guidedTourPaused = false
let firstVisitGuideTimer
let toastTimer
let introActive = true
let experienceStarted = !isStandalone
let activeZone = 0
let triggerRobotReaction = () => {}
let setRobotFace = async () => {}
let setRobotChapterPose = () => {}
let updateArchitecture = () => {}
let setActiveArchitectureZone = () => {}
let updateAmbientParticles = () => {}
const activeMovementDirections = new Set()
const validMovementDirections = new Set(['forward', 'backward', 'left', 'right'])
const movementKeyDirections = new Map([
    ['w', 'forward'],
    ['arrowup', 'forward'],
    ['s', 'backward'],
    ['arrowdown', 'backward'],
    ['a', 'left'],
    ['arrowleft', 'left'],
    ['d', 'right'],
    ['arrowright', 'right']
])
const movementBounds = { minX: -470, maxX: 470, minZ: 35, maxZ: 920 }
const movementForward = new THREE.Vector3()
const movementRight = new THREE.Vector3()
const movementDelta = new THREE.Vector3()
const movementNextTarget = new THREE.Vector3()
const movementWorldUp = new THREE.Vector3(0, 1, 0)
let movementFrameTimestamp = 0

function isMobilePortraitViewport(width, height) {
    return width <= mobileExhibitionBreakpoint && height > width
}

function getResponsiveCameraFov(width, height) {
    return isMobilePortraitViewport(width, height) ? 38 : 34
}

function setStorySheetCollapsed(collapsed) {
    if (!ui.storyPanel || !ui.storyHandle) return
    ui.storyPanel.classList.toggle('is-sheet-collapsed', collapsed)
    ui.storyHandle.setAttribute('aria-expanded', String(!collapsed))
    ui.storyHandle.setAttribute('aria-label', collapsed ? '展開內容面板' : '收合內容面板')
}

function setStoryPanelOpen(open) {
    ui.storyPanel?.classList.toggle('is-closed', !open)
    exhibitionRoot.classList.toggle('is-story-focus', Boolean(open && experienceStarted && isStandalone))
}

function setStatus(message, state = 'loading') {
    if (!ui.status || !ui.statusText) return
    ui.statusText.textContent = message
    ui.status.classList.toggle('is-ready', state === 'ready')
    ui.status.classList.toggle('is-error', state === 'error')
}

function setMovementDirection(direction, active) {
    if (!validMovementDirections.has(direction)) return
    if (active) activeMovementDirections.add(direction)
    else activeMovementDirections.delete(direction)
    exhibitionRoot.classList.toggle('is-moving', activeMovementDirections.size > 0)
    ui.movementButtons.forEach((button) => {
        button.classList.toggle('is-active', activeMovementDirections.has(button.dataset.move))
    })
}

function clearMovementDirections() {
    activeMovementDirections.clear()
    exhibitionRoot.classList.remove('is-moving')
    ui.movementButtons.forEach((button) => button.classList.remove('is-active'))
}

function moveCameraByDistance(distance) {
    if (!distance || !activeMovementDirections.size || !camera || !controls || introActive || cameraTransition) return
    camera.getWorldDirection(movementForward)
    movementForward.y = 0
    if (movementForward.lengthSq() < 0.0001) movementForward.set(0, 0, -1)
    movementForward.normalize()
    movementRight.crossVectors(movementForward, movementWorldUp).normalize()
    movementDelta.set(0, 0, 0)

    if (activeMovementDirections.has('forward')) movementDelta.add(movementForward)
    if (activeMovementDirections.has('backward')) movementDelta.sub(movementForward)
    if (activeMovementDirections.has('right')) movementDelta.add(movementRight)
    if (activeMovementDirections.has('left')) movementDelta.sub(movementRight)
    if (movementDelta.lengthSq() < 0.0001) return

    movementDelta.normalize().multiplyScalar(distance)
    movementNextTarget.copy(controls.target).add(movementDelta)
    movementNextTarget.x = THREE.MathUtils.clamp(movementNextTarget.x, movementBounds.minX, movementBounds.maxX)
    movementNextTarget.z = THREE.MathUtils.clamp(movementNextTarget.z, movementBounds.minZ, movementBounds.maxZ)
    movementDelta.subVectors(movementNextTarget, controls.target)
    camera.position.add(movementDelta)
    controls.target.add(movementDelta)
    controls.update()
}

function updateFreeMovement(timestamp) {
    const elapsed = movementFrameTimestamp ? Math.min((timestamp - movementFrameTimestamp) / 1000, 0.05) : 0
    movementFrameTimestamp = timestamp
    if (!elapsed) return
    moveCameraByDistance(150 * elapsed)
}

function setLoadingProgress(key, loaded, total) {
    const value = total > 0 ? Math.min(loaded / total, 1) : 0
    loadingProgress.set(key, value)
    const average = [...loadingProgress.values()].reduce((sum, item) => sum + item, 0) / loadingProgress.size
    const percentage = Math.min(Math.round(average * 100), 99)
    if (ui.progressBar) ui.progressBar.style.width = `${percentage}%`
    if (ui.progressText) ui.progressText.textContent = `載入展場模型 ${percentage}%`
}

function completeLoading() {
    if (ui.progressBar) ui.progressBar.style.width = '100%'
    if (ui.progressText) ui.progressText.textContent = isStandalone ? 'RURU 已就位，展間準備完成' : '展間準備完成'

    if (isStandalone && ui.loader) {
        ui.loader.classList.add('is-ready')
        if (ui.loaderActions) ui.loaderActions.hidden = false
        setStatus('等待入場')
        return
    }

    ui.loader?.classList.add('is-hidden')
}

function showLoadError() {
    setStatus('展間載入失敗', 'error')
    if (ui.progressText) ui.progressText.textContent = '模型無法載入，請檢查網路後再試一次。'
    if (ui.retry) ui.retry.hidden = false
}

function showToast(message) {
    if (!ui.toast) return
    window.clearTimeout(toastTimer)
    ui.toast.textContent = message
    ui.toast.classList.add('is-visible')
    toastTimer = window.setTimeout(() => ui.toast.classList.remove('is-visible'), 2200)
}

function setGuide(open) {
    if (!ui.guide || !ui.help) return
    window.clearTimeout(firstVisitGuideTimer)
    ui.guide.classList.toggle('is-closed', !open)
    ui.help.setAttribute('aria-expanded', String(open))
}

const GUIDE_SEEN_STORAGE_KEY = 'riease-exhibition-guide-seen'

function showFirstVisitGuide() {
    let seen = false
    try {
        seen = window.localStorage.getItem(GUIDE_SEEN_STORAGE_KEY) === '1'
        window.localStorage.setItem(GUIDE_SEEN_STORAGE_KEY, '1')
    } catch (error) { /* 無痕模式等情境無法使用 localStorage，每次都顯示 */ }
    if (seen) return
    setGuide(true)
    firstVisitGuideTimer = window.setTimeout(() => setGuide(false), 8000)
}

function loadModel(key, url) {
    return new Promise((resolve, reject) => {
        loader.load(
            url,
            (result) => {
                loadingProgress.set(key, 1)
                resolve(result.scene.children[0] || result.scene)
            },
            (event) => setLoadingProgress(key, event.loaded, event.total),
            reject
        )
    })
}

function setObjectTransform(object, { position, rotation, scale }) {
    if (position) object.position.set(...position)
    if (rotation) object.rotation.set(...rotation)
    if (scale) object.scale.set(...scale)
}

function configureModels() {
    exhibit.name = 'exhibit'
    exhibit.visible = false
    setObjectTransform(exhibit, {
        position: [0, 5, 690],
        rotation: [exhibit.rotation.x, exhibit.rotation.y, 3.1],
        scale: [0.76, 0.76, 0.76]
    })

    exhibit.traverse((object) => {
        if (!object.isMesh) return
        object.receiveShadow = true
        object.castShadow = false
    })

    robot.name = 'robot'
    setObjectTransform(robot, {
        position: [250, 10, 300],
        rotation: [robot.rotation.x, 3.9, robot.rotation.z],
        scale: [0.34, 0.34, 0.34]
    })

    robot.traverse((object) => {
        if (!object.isMesh || !object.material) return
        object.castShadow = true
        object.receiveShadow = true
        const materials = Array.isArray(object.material) ? object.material : [object.material]
        const refinedMaterials = materials.map((material) => {
            if (!material.isMeshStandardMaterial || material.name?.includes('CuteRobotFaceTexture')) return material
            const refinedMaterial = material.clone()
            refinedMaterial.emissive = new THREE.Color(0x6f8f97)
            refinedMaterial.emissiveIntensity = 0.08
            refinedMaterial.roughness = Math.max(refinedMaterial.roughness ?? 0.5, 0.42)
            refinedMaterial.metalness = Math.min(refinedMaterial.metalness ?? 0.1, 0.36)
            return refinedMaterial
        })
        object.material = Array.isArray(object.material) ? refinedMaterials : refinedMaterials[0]
    })

    leftArm = robot.getObjectByName('Bone026')
    hiddenBones = robot.getObjectByName('Bone001')
    if (hiddenBones) hiddenBones.visible = false
}

function makeShowcaseTexture(slideIndex = 0) {
    const slides = [
        { label: 'RICH INFORMATION', title: 'EASY DELIVERY', subtitle: '把複雜，化成清楚的下一步' },
        { label: 'WHO WE ARE', title: 'RIEASE', subtitle: '2009 年成立 · 桃園 · 客製軟體解決方案' },
        { label: 'SIX CAPABILITIES', title: 'ONE JOURNEY', subtitle: '網站 · 系統 · 整合 · 轉型 · 資安 · 維運' },
        { label: 'HOW WE DELIVER', title: 'VISIBLE PROCESS', subtitle: '需求洞察到交付維運的完整閉環' },
        { label: 'TRUST BY DESIGN', title: 'ISO 27001', subtitle: '資安、品質與長期合作的共同標準' },
        { label: 'BUILD WHAT IS NEXT', title: 'LET\'S TALK', subtitle: '下一個改變，從一場對話開始' }
    ]
    const slide = slides[slideIndex % slides.length]
    const textureCanvas = document.createElement('canvas')
    textureCanvas.width = 1200
    textureCanvas.height = 840
    const context = textureCanvas.getContext('2d')
    const gradient = context.createLinearGradient(0, 0, 1200, 840)

    gradient.addColorStop(0, '#10171a')
    gradient.addColorStop(0.6, '#080b0d')
    gradient.addColorStop(1, '#040607')
    context.fillStyle = gradient
    context.fillRect(0, 0, 1200, 840)

    context.strokeStyle = 'rgba(174, 213, 0, 0.14)'
    context.lineWidth = 2
    for (let x = -300; x < 1500; x += 120) {
        context.beginPath()
        context.moveTo(x, 0)
        context.lineTo(x + 520, 840)
        context.stroke()
    }

    context.fillStyle = '#aed500'
    context.fillRect(88, 104, 156, 10)
    context.font = '700 28px Arial, sans-serif'
    context.fillText(slide.label, 90, 184)

    context.fillStyle = '#ffffff'
    context.font = '900 82px Arial, sans-serif'
    context.fillText(slide.title, 84, 334)

    context.fillStyle = 'rgba(255, 255, 255, 0.64)'
    context.font = '500 32px sans-serif'
    context.fillText(slide.subtitle, 90, 414)

    context.strokeStyle = 'rgba(174, 213, 0, 0.6)'
    context.lineWidth = 3
    context.beginPath()
    context.arc(1010, 650, 116, 0, Math.PI * 2)
    context.stroke()
    context.fillStyle = '#aed500'
    context.font = '900 86px Arial, sans-serif'
    context.textAlign = 'center'
    context.fillText(String(slideIndex).padStart(2, '0'), 1010, 680)

    context.textAlign = 'left'
    context.fillStyle = 'rgba(255, 255, 255, 0.38)'
    context.font = '500 22px Arial, sans-serif'
    context.fillText('CLICK TO CONTINUE THE STORY', 90, 738)

    const texture = new THREE.CanvasTexture(textureCanvas)
    texture.encoding = THREE.sRGBEncoding
    return texture
}

function createExhibitionScreen() {
    const geometry = new THREE.BoxGeometry(125, 90, 1)
    const video = document.getElementById('video')
    const hasVideoSource = Boolean(video?.querySelector('source[src]') || video?.getAttribute('src'))
    const texture = hasVideoSource ? new THREE.VideoTexture(video) : makeShowcaseTexture(0)
    const material = new THREE.MeshBasicMaterial({ map: texture, toneMapped: false })

    screenMesh = new THREE.Mesh(geometry, material)
    screenMesh.position.set(20, 200, 677)
    screenMesh.name = 'screen'
    screenMesh.userData.hasVideo = hasVideoSource
    screenMesh.userData.slide = 0
    scene.add(screenMesh)

    if (!hasVideoSource) return

    const useFallbackTexture = () => {
        if (!screenMesh.userData.hasVideo) return
        const previousTexture = screenMesh.material.map
        screenMesh.userData.hasVideo = false
        screenMesh.material.map = makeShowcaseTexture(currentChapter)
        screenMesh.material.needsUpdate = true
        previousTexture?.dispose()
    }

    video.addEventListener('error', useFallbackTexture, { once: true })
    video.querySelectorAll('source').forEach((source) => {
        source.addEventListener('error', useFallbackTexture, { once: true })
    })

    if (video.error) useFallbackTexture()
    else video.play().catch(useFallbackTexture)
}

function makeZoneLabelTexture({ index, kicker, title, subtitle, accent = '#aed500' }) {
    const labelCanvas = document.createElement('canvas')
    labelCanvas.width = 768
    labelCanvas.height = 270
    const context = labelCanvas.getContext('2d')
    const background = context.createLinearGradient(0, 0, 768, 270)

    background.addColorStop(0, 'rgba(8, 13, 16, 0.96)')
    background.addColorStop(0.72, 'rgba(8, 13, 16, 0.84)')
    background.addColorStop(1, 'rgba(8, 13, 16, 0.18)')
    context.fillStyle = background
    context.fillRect(0, 0, 768, 270)

    context.fillStyle = accent
    context.fillRect(31, 28, 87, 6)
    context.font = '800 21px Arial, sans-serif'
    context.fillText(`${index}  ${kicker}`, 31, 71)

    context.fillStyle = '#ffffff'
    context.font = '800 50px "PingFang TC", "Microsoft JhengHei", sans-serif'
    context.fillText(title, 30, 143)

    context.fillStyle = 'rgba(255, 255, 255, 0.62)'
    context.font = '500 22px "PingFang TC", "Microsoft JhengHei", sans-serif'
    context.fillText(subtitle, 31, 194)

    context.globalAlpha = 0.34
    context.strokeStyle = accent
    context.lineWidth = 2
    context.strokeRect(14, 14, 740, 242)
    context.globalAlpha = 1

    const texture = new THREE.CanvasTexture(labelCanvas)
    texture.encoding = THREE.sRGBEncoding
    return texture
}

function createLegacyExperienceArchitecture() {
    const zoneGroups = []
    const animatedObjects = []
    const structuralMaterial = new THREE.MeshStandardMaterial({
        color: 0x10171a,
        roughness: 0.46,
        metalness: 0.72
    })
    const softWhiteMaterial = new THREE.MeshStandardMaterial({
        color: 0xdce6e8,
        emissive: 0x6c7e82,
        emissiveIntensity: 0.12,
        roughness: 0.62,
        metalness: 0.18
    })

    function makeAccentMaterial(activeIntensity = 1.3, opacity = 0.92) {
        const material = new THREE.MeshStandardMaterial({
            color: 0x617800,
            emissive: 0xaed500,
            emissiveIntensity: 0.24,
            roughness: 0.34,
            metalness: 0.48,
            transparent: opacity < 1,
            opacity
        })
        material.userData.activeIntensity = activeIntensity
        material.userData.inactiveIntensity = 0.18
        material.userData.activeOpacity = opacity
        material.userData.inactiveOpacity = Math.min(opacity, 0.08)
        return material
    }

    function registerAccent(group, material) {
        if (!group.userData.accentMaterials.includes(material)) group.userData.accentMaterials.push(material)
        return material
    }

    function addBox(group, size, position, material = structuralMaterial) {
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), material)
        mesh.position.set(...position)
        mesh.castShadow = false
        mesh.receiveShadow = false
        group.add(mesh)
        return mesh
    }

    function addZoneLabel(group, position, scale = [150, 53]) {
        const material = new THREE.SpriteMaterial({
            map: makeZoneLabelTexture(chapterZoneData[group.userData.chapter]),
            transparent: true,
            depthWrite: false,
            opacity: 0.03
        })
        material.userData.activeOpacity = 1
        material.userData.inactiveOpacity = 0.03
        const sprite = new THREE.Sprite(material)
        sprite.position.set(...position)
        sprite.scale.set(scale[0], scale[1], 1)
        sprite.renderOrder = 2
        group.userData.labelMaterials.push(material)
        group.add(sprite)
        return sprite
    }

    function createZone(chapter, position, ringRadius = 56) {
        const group = new THREE.Group()
        group.name = `chapter-zone-${chapter}`
        group.position.set(...position)
        group.userData.chapter = chapter
        group.userData.accentMaterials = []
        group.userData.labelMaterials = []

        const ringMaterial = new THREE.MeshBasicMaterial({
            color: 0xaed500,
            transparent: true,
            opacity: 0.12,
            side: THREE.DoubleSide,
            depthWrite: false
        })
        ringMaterial.userData.activeOpacity = 0.62
        ringMaterial.userData.inactiveOpacity = 0.025
        const floorRing = new THREE.Mesh(new THREE.RingGeometry(ringRadius - 1.4, ringRadius, 72), ringMaterial)
        floorRing.rotation.x = -Math.PI / 2
        floorRing.position.y = 1.1
        group.userData.labelMaterials.push(ringMaterial)
        group.add(floorRing)

        zoneGroups[chapter] = group
        scene.add(group)
        return group
    }

    const pathMaterial = new THREE.MeshBasicMaterial({
        color: 0xaed500,
        transparent: true,
        opacity: 0.22,
        depthWrite: false
    })
    const pathGeometry = new THREE.BoxGeometry(15, 0.8, 3.2)
    for (let index = 0; index < 25; index += 1) {
        const progress = index / 24
        const pathSegment = new THREE.Mesh(pathGeometry, pathMaterial)
        pathSegment.position.set(
            -115 + Math.sin(progress * Math.PI * 3.2) * 72,
            0.8,
            82 + progress * 595
        )
        pathSegment.rotation.y = Math.sin(progress * Math.PI * 3.2) * 0.42
        scene.add(pathSegment)
    }

    const canopyMaterial = new THREE.MeshBasicMaterial({
        color: 0xaed500,
        transparent: true,
        opacity: 0.1,
        depthWrite: false
    })
    ;[115, 170, 225].forEach((radius, index) => {
        const halo = new THREE.Mesh(new THREE.TorusGeometry(radius, 1.1, 6, 96), canopyMaterial.clone())
        halo.position.set(5, 305 + index * 8, 520)
        halo.rotation.x = Math.PI / 2 + (index - 1) * 0.08
        halo.userData.animation = 'canopy'
        halo.userData.speed = 0.00005 * (index % 2 ? -1 : 1)
        animatedObjects.push(halo)
        scene.add(halo)
    })

    const particlePositions = new Float32Array(210 * 3)
    for (let index = 0; index < 210; index += 1) {
        const offset = index * 3
        particlePositions[offset] = (Math.random() - 0.5) * 880
        particlePositions[offset + 1] = 28 + Math.random() * 310
        particlePositions[offset + 2] = 80 + Math.random() * 700
    }
    const particleGeometry = new THREE.BufferGeometry()
    particleGeometry.setAttribute('position', new THREE.BufferAttribute(particlePositions, 3))
    const particles = new THREE.Points(
        particleGeometry,
        new THREE.PointsMaterial({
            color: 0xc8ee3d,
            size: 1.55,
            transparent: true,
            opacity: 0.34,
            depthWrite: false
        })
    )
    particles.name = 'ambient-data-particles'
    scene.add(particles)

    const entryZone = createZone(0, [-40, 0, 330], 68)
    const entryAccent = registerAccent(entryZone, makeAccentMaterial(1.5))
    ;[-78, -39, 0, 39, 78].forEach((x, index) => {
        const height = 58 + (index % 3) * 28
        addBox(entryZone, [7, height, 7], [x, height / 2, 0], index === 2 ? entryAccent : structuralMaterial)
        const cap = addBox(entryZone, [17, 3, 17], [x, height + 5, 0], entryAccent)
        cap.rotation.y = index * 0.24
    })
    const entrySignal = new THREE.Mesh(new THREE.IcosahedronGeometry(15, 1), entryAccent)
    entrySignal.position.set(0, 138, 0)
    entrySignal.userData.animation = 'core'
    animatedObjects.push(entrySignal)
    entryZone.add(entrySignal)
    addZoneLabel(entryZone, [0, 190, 0], [164, 58])

    const identityZone = createZone(1, [-238, 0, 535], 92)
    const identityAccent = registerAccent(identityZone, makeAccentMaterial(1.55))
    const identityValues = ['2009', '25+', '1000+']
    ;[62, 104, 142].forEach((height, index) => {
        const x = (index - 1) * 62
        addBox(identityZone, [42, height, 42], [x, height / 2, 0], index === 1 ? identityAccent : structuralMaterial)
        addBox(identityZone, [44, 3, 44], [x, height + 2, 0], identityAccent)
        const valueMaterial = new THREE.SpriteMaterial({
            map: makeZoneLabelTexture({ index: `0${index + 1}`, kicker: 'MILESTONE', title: identityValues[index], subtitle: ['成立於桃園', '年業界經驗', '件案件作品'][index] }),
            transparent: true,
            depthWrite: false,
            opacity: 0.02
        })
        valueMaterial.userData.activeOpacity = 1
        valueMaterial.userData.inactiveOpacity = 0.02
        const value = new THREE.Sprite(valueMaterial)
        value.position.set(x, height + 28, 0)
        value.scale.set(72, 25, 1)
        identityZone.userData.labelMaterials.push(valueMaterial)
        identityZone.add(value)
    })
    const identityArc = new THREE.Mesh(new THREE.TorusGeometry(112, 1.5, 8, 72, Math.PI * 1.25), identityAccent)
    identityArc.position.set(0, 76, 18)
    identityArc.rotation.z = -Math.PI * 0.12
    identityZone.add(identityArc)
    addZoneLabel(identityZone, [0, 212, 0], [156, 55])

    const capabilityZone = createZone(2, [12, 0, 642], 156)
    const capabilityAccent = registerAccent(capabilityZone, makeAccentMaterial(1.7))
    const capabilityNames = ['WEB', 'SYSTEM', 'CONNECT', 'DX', 'SECURITY', 'CARE']
    capabilityNames.forEach((name, index) => {
        const angle = (index / capabilityNames.length) * Math.PI * 2
        const node = new THREE.Mesh(new THREE.OctahedronGeometry(10, 0), capabilityAccent)
        node.position.set(Math.cos(angle) * 148, 105 + Math.sin(angle) * 52, Math.sin(angle) * 18)
        node.userData.animation = 'capability'
        node.userData.phase = angle
        node.userData.baseY = node.position.y
        animatedObjects.push(node)
        capabilityZone.add(node)

        const stemHeight = Math.max(18, node.position.y - 12)
        addBox(capabilityZone, [1.5, stemHeight, 1.5], [node.position.x, stemHeight / 2, node.position.z], capabilityAccent)

        const labelMaterial = new THREE.SpriteMaterial({
            map: makeZoneLabelTexture({ index: String(index + 1).padStart(2, '0'), kicker: 'CAPABILITY', title: name, subtitle: '完整服務節點' }),
            transparent: true,
            depthWrite: false,
            opacity: 0.01
        })
        labelMaterial.userData.activeOpacity = 0.84
        labelMaterial.userData.inactiveOpacity = 0.01
        const label = new THREE.Sprite(labelMaterial)
        label.position.copy(node.position).add(new THREE.Vector3(0, 24, 0))
        label.scale.set(52, 18, 1)
        capabilityZone.userData.labelMaterials.push(labelMaterial)
        capabilityZone.add(label)
    })
    addZoneLabel(capabilityZone, [0, 302, 0], [164, 58])

    const processZone = createZone(3, [-232, 0, 568], 104)
    const processAccent = registerAccent(processZone, makeAccentMaterial(1.6, 0.86))
    for (let index = 0; index < 6; index += 1) {
        const z = -82 + index * 30
        const height = 56 + index * 7
        addBox(processZone, [4, height, 4], [-48, height / 2, z], index === 5 ? processAccent : structuralMaterial)
        addBox(processZone, [4, height, 4], [48, height / 2, z], index === 5 ? processAccent : structuralMaterial)
        addBox(processZone, [100, 4, 4], [0, height, z], processAccent)

        const stepPlate = addBox(processZone, [20, 1.4, 14], [0, 1.6, z], processAccent)
        stepPlate.userData.animation = 'process'
        stepPlate.userData.phase = index * 0.55
        stepPlate.userData.baseY = 1.6
        animatedObjects.push(stepPlate)
    }
    addZoneLabel(processZone, [0, 158, 18], [154, 54])

    const trustZone = createZone(4, [244, 0, 515], 112)
    const trustAccent = registerAccent(trustZone, makeAccentMaterial(1.85))
    ;[78, 132, 92].forEach((height, index) => {
        const x = (index - 1) * 62
        addBox(trustZone, [48, height, 38], [x, height / 2, 0], index === 1 ? structuralMaterial : softWhiteMaterial)
        addBox(trustZone, [50, 3, 40], [x, height + 2, 0], trustAccent)
    })
    const shieldOuter = new THREE.Mesh(new THREE.TorusGeometry(38, 3.2, 8, 48), trustAccent)
    shieldOuter.position.set(0, 174, 4)
    trustZone.add(shieldOuter)
    const shieldCore = addBox(trustZone, [34, 46, 6], [0, 170, 4], trustAccent)
    shieldCore.rotation.z = Math.PI / 4
    addZoneLabel(trustZone, [0, 244, 0], [158, 56])

    const futureZone = createZone(5, [78, 0, 382], 102)
    const futureAccent = registerAccent(futureZone, makeAccentMaterial(2.05, 0.96))
    ;[72, 91, 112].forEach((radius, index) => {
        const portalRing = new THREE.Mesh(new THREE.TorusGeometry(radius, index === 1 ? 2.8 : 1.4, 8, 96), futureAccent)
        portalRing.position.y = 112
        portalRing.rotation.y = (index - 1) * 0.34
        portalRing.rotation.z = index * 0.42
        portalRing.userData.animation = 'portal'
        portalRing.userData.speed = 0.00018 * (index % 2 ? -1 : 1)
        animatedObjects.push(portalRing)
        futureZone.add(portalRing)
    })
    const futureCore = new THREE.Mesh(new THREE.IcosahedronGeometry(23, 1), futureAccent)
    futureCore.position.y = 112
    futureCore.userData.animation = 'future-core'
    animatedObjects.push(futureCore)
    futureZone.add(futureCore)
    addZoneLabel(futureZone, [0, 246, 0], [162, 57])

    setActiveArchitectureZone = (chapter) => {
        activeZone = Math.max(0, Math.min(chapter, zoneGroups.length - 1))
        zoneGroups.forEach((group, index) => {
            group.visible = index === activeZone
        })
    }

    updateArchitecture = (timestamp) => {
        const time = timestamp * 0.001
        particles.rotation.y = Math.sin(time * 0.08) * 0.04
        particles.position.y = Math.sin(time * 0.22) * 4
        pathMaterial.opacity = 0.18 + Math.sin(time * 1.4) * 0.05

        zoneGroups.forEach((group, chapter) => {
            const isActive = chapter === activeZone
            const targetScale = isActive ? 1.035 : 1
            const nextScale = THREE.MathUtils.lerp(group.scale.x, targetScale, 0.065)
            group.scale.setScalar(nextScale)

            group.userData.accentMaterials.forEach((material) => {
                const intensity = isActive ? material.userData.activeIntensity : material.userData.inactiveIntensity
                const opacity = isActive ? material.userData.activeOpacity : material.userData.inactiveOpacity
                material.emissiveIntensity = THREE.MathUtils.lerp(material.emissiveIntensity, intensity, 0.08)
                material.opacity = THREE.MathUtils.lerp(material.opacity, opacity, 0.08)
            })
            group.userData.labelMaterials.forEach((material) => {
                const opacity = isActive ? material.userData.activeOpacity : material.userData.inactiveOpacity
                material.opacity = THREE.MathUtils.lerp(material.opacity, opacity, 0.08)
            })
        })

        animatedObjects.forEach((object) => {
            if (object.userData.animation === 'canopy') {
                object.rotation.z += object.userData.speed
                object.rotation.y = Math.sin(time * 0.12) * 0.06
            } else if (object.userData.animation === 'core') {
                object.rotation.x = time * 0.38
                object.rotation.y = time * 0.56
                object.position.y = 138 + Math.sin(time * 1.2) * 4
            } else if (object.userData.animation === 'capability') {
                object.rotation.y = time * 0.8 + object.userData.phase
                object.position.y = object.userData.baseY + Math.sin(time * 1.4 + object.userData.phase) * 2
            } else if (object.userData.animation === 'process') {
                object.position.y = object.userData.baseY + Math.sin(time * 2.1 + object.userData.phase) * 0.32
            } else if (object.userData.animation === 'portal') {
                object.rotation.z += object.userData.speed
                object.rotation.y += object.userData.speed * 0.42
            } else if (object.userData.animation === 'future-core') {
                object.rotation.x = time * 0.7
                object.rotation.y = time * 0.92
                object.scale.setScalar(1 + Math.sin(time * 1.8) * 0.08)
            }
        })
    }

    setActiveArchitectureZone(0)
}

function createBoxPavilionLegacy() {
    const pavilion = new THREE.Group()
    pavilion.name = 'riease-pavilion'
    scene.add(pavilion)

    const zoneGroups = []
    const animatedObjects = []
    const shellMaterial = new THREE.MeshStandardMaterial({
        color: 0x151b1e,
        roughness: 0.76,
        metalness: 0.22
    })
    const wallMaterial = new THREE.MeshStandardMaterial({
        color: 0x222a2d,
        roughness: 0.68,
        metalness: 0.12
    })
    const floorMaterial = new THREE.MeshStandardMaterial({
        color: 0x30383b,
        roughness: 0.84,
        metalness: 0.08
    })
    const lineMaterial = new THREE.MeshStandardMaterial({
        color: 0x6e8300,
        emissive: 0xaed500,
        emissiveIntensity: 0.34,
        roughness: 0.44,
        metalness: 0.35
    })
    const glassMaterial = new THREE.MeshStandardMaterial({
        color: 0x172227,
        emissive: 0x23363d,
        emissiveIntensity: 0.18,
        transparent: true,
        opacity: 0.72,
        roughness: 0.24,
        metalness: 0.42,
        side: THREE.DoubleSide
    })

    function addBox(parent, size, position, material = shellMaterial) {
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), material)
        mesh.position.set(...position)
        mesh.receiveShadow = true
        parent.add(mesh)
        return mesh
    }

    // A continuous architectural shell replaces the previous black void.
    addBox(pavilion, [1080, 12, 1080], [0, -4, 420], floorMaterial)
    addBox(pavilion, [286, 3, 970], [0, 3.5, 385], wallMaterial)
    addBox(pavilion, [8, 2, 930], [-148, 6, 390], lineMaterial)
    addBox(pavilion, [8, 2, 930], [148, 6, 390], lineMaterial)

    ;[-520, 520].forEach((x) => {
        ;[65, 330, 595, 860].forEach((z) => {
            addBox(pavilion, [16, 258, 236], [x, 129, z], wallMaterial)
            addBox(pavilion, [5, 222, 188], [x + (x < 0 ? 9 : -9), 126, z], glassMaterial)
        })
        addBox(pavilion, [30, 282, 30], [x, 141, -95], shellMaterial)
        addBox(pavilion, [30, 282, 30], [x, 141, 955], shellMaterial)
    })

    ;[-95, 155, 405, 655, 905].forEach((z, index) => {
        addBox(pavilion, [1070, 12, 18], [0, 276, z], shellMaterial)
        addBox(pavilion, [690, 3, 8], [0, 269, z + 2], lineMaterial)
        if (index < 4) {
            const canopy = addBox(pavilion, [770, 3, 116], [0, 273, z + 125], glassMaterial)
            canopy.material = glassMaterial.clone()
            canopy.material.opacity = 0.42
        }
    })

    // A quiet rear frame makes the original model read as one hero booth.
    addBox(pavilion, [1060, 260, 18], [0, 130, 962], wallMaterial)
    addBox(pavilion, [780, 6, 12], [0, 252, 950], lineMaterial)
    ;[-410, 410].forEach((x) => addBox(pavilion, [6, 204, 12], [x, 135, 950], lineMaterial))

    // Side benches and low wall washes make the circulation route feel occupied.
    ;[-1, 1].forEach((side) => {
        ;[185, 455, 725].forEach((z) => {
            addBox(pavilion, [132, 18, 48], [side * 420, 12, z], shellMaterial)
            addBox(pavilion, [116, 3, 36], [side * 420, 22.5, z], wallMaterial)
        })
    })

    const frontFrame = new THREE.Group()
    frontFrame.name = 'pavilion-entry-frame'
    addBox(frontFrame, [28, 252, 28], [-455, 126, -102], shellMaterial)
    addBox(frontFrame, [28, 252, 28], [455, 126, -102], shellMaterial)
    addBox(frontFrame, [938, 26, 28], [0, 252, -102], shellMaterial)
    addBox(frontFrame, [260, 4, 8], [0, 238, -116], lineMaterial)
    pavilion.add(frontFrame)

    const zonePlacements = [
        [0, 0, 205],
        [1, -325, 340],
        [2, 325, 340],
        [3, -345, 575],
        [4, 345, 575],
        [5, 0, 500]
    ]

    function createAccentMaterial() {
        const material = new THREE.MeshStandardMaterial({
            color: 0x3c4705,
            emissive: 0xaed500,
            emissiveIntensity: 0.06,
            roughness: 0.42,
            metalness: 0.38
        })
        material.userData.activeIntensity = 0.62
        material.userData.inactiveIntensity = 0.06
        material.userData.activeColor = new THREE.Color(0x91b000)
        material.userData.inactiveColor = new THREE.Color(0x3c4705)
        return material
    }

    function makeZone(chapter, x, z) {
        const group = new THREE.Group()
        group.name = `pavilion-zone-${chapter}`
        group.position.set(x, 0, z)
        group.userData.chapter = chapter
        group.userData.accentMaterials = []
        group.userData.labelMaterials = []

        addBox(group, [232, 148, 12], [0, 83, 34], shellMaterial)
        addBox(group, [218, 132, 4], [0, 83, 26], glassMaterial)
        addBox(group, [236, 4, 16], [0, 159, 34], wallMaterial)
        addBox(group, [166, 16, 88], [0, 8, -18], wallMaterial)

        const accent = createAccentMaterial()
        group.userData.accentMaterials.push(accent)
        addBox(group, [174, 3, 72], [0, 17.5, -18], accent)
        addBox(group, [6, 128, 5], [-105, 83, 21], accent)

        const labelMaterial = new THREE.SpriteMaterial({
            map: makeZoneLabelTexture(chapterZoneData[chapter]),
            transparent: true,
            depthWrite: false,
            opacity: 0
        })
        labelMaterial.userData.activeOpacity = 0
        labelMaterial.userData.inactiveOpacity = 0
        const label = new THREE.Sprite(labelMaterial)
        label.position.set(0, 146, 24)
        label.scale.set(132, 47, 1)
        label.renderOrder = 3
        group.userData.labelMaterials.push(labelMaterial)
        group.add(label)

        zoneGroups[chapter] = group
        pavilion.add(group)
        return { group, accent }
    }

    const zones = zonePlacements.map(([chapter, x, z]) => makeZone(chapter, x, z))

    // 00 — one clear entry signal.
    {
        const { group, accent } = zones[0]
        const ring = new THREE.Mesh(new THREE.TorusGeometry(44, 3.5, 8, 64), accent)
        ring.position.set(0, 78, -10)
        group.add(ring)
        const core = new THREE.Mesh(new THREE.BoxGeometry(42, 42, 42), accent)
        core.position.set(0, 78, -10)
        core.rotation.set(0.42, 0.54, 0.72)
        core.userData.chapter = 0
        animatedObjects.push(core)
        group.add(core)
    }

    // 01 — a compact timeline, kept within its own bay.
    {
        const { group, accent } = zones[1]
        ;[48, 72, 102].forEach((height, index) => {
            const bar = addBox(group, [34, height, 34], [(index - 1) * 52, 20 + height / 2, -16], index === 1 ? accent : wallMaterial)
            bar.userData.baseY = bar.position.y
        })
    }

    // 02 — six capabilities share a single orbit instead of six floating labels.
    {
        const { group, accent } = zones[2]
        const orbit = new THREE.Mesh(new THREE.TorusGeometry(54, 2, 7, 64), accent)
        orbit.position.set(0, 82, -12)
        group.add(orbit)
        for (let index = 0; index < 6; index += 1) {
            const angle = (index / 6) * Math.PI * 2
            const node = new THREE.Mesh(new THREE.OctahedronGeometry(7, 0), accent)
            node.position.set(Math.cos(angle) * 54, 82 + Math.sin(angle) * 54, -12)
            group.add(node)
        }
        addBox(group, [14, 14, 14], [0, 82, -12], accent).rotation.set(0.4, 0.4, 0.4)
    }

    // 03 — six delivery steps read as one ascending object.
    {
        const { group, accent } = zones[3]
        for (let index = 0; index < 6; index += 1) {
            const height = 18 + index * 13
            addBox(group, [22, height, 30], [-68 + index * 27, 20 + height / 2, -13], index === 5 ? accent : wallMaterial)
        }
    }

    // 04 — one restrained trust mark.
    {
        const { group, accent } = zones[4]
        const shield = new THREE.Mesh(new THREE.TorusGeometry(48, 3.5, 8, 64), accent)
        shield.position.set(0, 82, -12)
        group.add(shield)
        const core = addBox(group, [46, 46, 8], [0, 82, -12], accent)
        core.rotation.z = Math.PI / 4
    }

    // 05 — a calm portal closes the route without spilling across other zones.
    {
        const { group, accent } = zones[5]
        ;[34, 50, 66].forEach((radius, index) => {
            const ring = new THREE.Mesh(new THREE.TorusGeometry(radius, index === 1 ? 2.8 : 1.4, 7, 64), accent)
            ring.position.set(0, 84, -10)
            ring.rotation.y = (index - 1) * 0.18
            ring.userData.chapter = 5
            ring.userData.speed = (index % 2 ? -1 : 1) * (0.00007 + index * 0.00002)
            animatedObjects.push(ring)
            group.add(ring)
        })
    }

    const pavilionLights = [
        [-390, 218, 180], [390, 218, 180],
        [-390, 218, 520], [390, 218, 520],
        [0, 230, 720]
    ]
    pavilionLights.forEach(([x, y, z], index) => {
        const light = new THREE.PointLight(index === 4 ? 0xbfe0ef : 0xd9e9ee, 0.16, 330)
        light.position.set(x, y, z)
        pavilion.add(light)
    })

    setActiveArchitectureZone = (chapter) => {
        activeZone = Math.max(0, Math.min(chapter, zoneGroups.length - 1))
        zoneGroups.forEach((group, index) => {
            group.visible = index === activeZone
        })
    }

    updateArchitecture = (timestamp) => {
        zoneGroups.forEach((group, chapter) => {
            const isActive = chapter === activeZone
            const targetScale = isActive ? 1.018 : 1
            const scale = THREE.MathUtils.lerp(group.scale.x, targetScale, 0.07)
            group.scale.setScalar(scale)

            group.userData.accentMaterials.forEach((material) => {
                const intensity = isActive ? material.userData.activeIntensity : material.userData.inactiveIntensity
                const color = isActive ? material.userData.activeColor : material.userData.inactiveColor
                material.emissiveIntensity = THREE.MathUtils.lerp(material.emissiveIntensity, intensity, 0.075)
                material.color.lerp(color, 0.075)
            })
            group.userData.labelMaterials.forEach((material) => {
                const opacity = isActive ? material.userData.activeOpacity : material.userData.inactiveOpacity
                material.opacity = THREE.MathUtils.lerp(material.opacity, opacity, 0.09)
            })
        })

        animatedObjects.forEach((object) => {
            if (object.userData.chapter !== activeZone) return
            if (object.userData.chapter === 0) {
                object.rotation.y = timestamp * 0.00024
                object.rotation.x = 0.42 + Math.sin(timestamp * 0.0007) * 0.08
            } else if (object.userData.chapter === 5) {
                object.rotation.z += object.userData.speed
            }
        })
    }

    setActiveArchitectureZone(0)
}

function createExperienceArchitecture() {
    const pavilion = new THREE.Group()
    pavilion.name = 'riease-cinematic-atrium'
    scene.add(pavilion)

    const atriumCenter = new THREE.Vector3(0, 0, 470)
    const zoneGroups = []
    const animatedObjects = []
    const routeCheckpoints = []
    const atlasPanelMaterials = []

    const surfaceCanvas = document.createElement('canvas')
    surfaceCanvas.width = 192
    surfaceCanvas.height = 192
    const surfaceContext = surfaceCanvas.getContext('2d')
    const surfacePixels = surfaceContext.createImageData(surfaceCanvas.width, surfaceCanvas.height)
    for (let offset = 0; offset < surfacePixels.data.length; offset += 4) {
        const grain = 118 + Math.floor(Math.random() * 21)
        surfacePixels.data[offset] = grain
        surfacePixels.data[offset + 1] = grain
        surfacePixels.data[offset + 2] = grain
        surfacePixels.data[offset + 3] = 255
    }
    surfaceContext.putImageData(surfacePixels, 0, 0)
    surfaceContext.globalAlpha = 0.18
    surfaceContext.strokeStyle = '#f0f0f0'
    for (let line = 0; line < 24; line += 1) {
        const y = Math.random() * surfaceCanvas.height
        surfaceContext.beginPath()
        surfaceContext.moveTo(0, y)
        surfaceContext.lineTo(surfaceCanvas.width, y + (Math.random() - 0.5) * 4)
        surfaceContext.stroke()
    }
    const surfaceBumpTexture = new THREE.CanvasTexture(surfaceCanvas)
    surfaceBumpTexture.wrapS = THREE.RepeatWrapping
    surfaceBumpTexture.wrapT = THREE.RepeatWrapping
    surfaceBumpTexture.repeat.set(6, 6)

    const glowCanvas = document.createElement('canvas')
    glowCanvas.width = 256
    glowCanvas.height = 256
    const glowContext = glowCanvas.getContext('2d')
    const glowGradient = glowContext.createRadialGradient(128, 128, 10, 128, 128, 126)
    glowGradient.addColorStop(0, 'rgba(255,255,255,0.9)')
    glowGradient.addColorStop(0.28, 'rgba(255,255,255,0.34)')
    glowGradient.addColorStop(0.68, 'rgba(255,255,255,0.08)')
    glowGradient.addColorStop(1, 'rgba(255,255,255,0)')
    glowContext.fillStyle = glowGradient
    glowContext.fillRect(0, 0, 256, 256)
    const glowTexture = new THREE.CanvasTexture(glowCanvas)

    const shellMaterial = new THREE.MeshStandardMaterial({
        color: 0x11191d,
        roughness: 0.44,
        metalness: 0.34,
        bumpMap: surfaceBumpTexture,
        bumpScale: 0.22,
        envMapIntensity: 0.88
    })
    const wallMaterial = new THREE.MeshStandardMaterial({
        color: 0x273238,
        emissive: 0x101a1f,
        emissiveIntensity: 0.16,
        roughness: 0.52,
        metalness: 0.26,
        bumpMap: surfaceBumpTexture,
        bumpScale: 0.16,
        envMapIntensity: 0.72
    })
    const floorMaterial = new THREE.MeshStandardMaterial({
        color: 0x1c272b,
        roughness: 0.76,
        metalness: 0.14,
        bumpMap: surfaceBumpTexture,
        bumpScale: 0.34,
        envMapIntensity: 0.52
    })
    const glassMaterial = new THREE.MeshPhysicalMaterial({
        color: 0x172a31,
        emissive: 0x173139,
        emissiveIntensity: 0.18,
        transparent: true,
        opacity: 0.46,
        roughness: 0.14,
        metalness: 0.04,
        transmission: 0.28,
        clearcoat: 0.86,
        clearcoatRoughness: 0.16,
        envMapIntensity: 1.28,
        side: THREE.DoubleSide,
        depthWrite: false
    })
    const limeLineMaterial = new THREE.MeshBasicMaterial({
        color: 0xb9e000,
        transparent: true,
        opacity: 0.52,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        side: THREE.DoubleSide
    })
    const architecturalLineMaterial = new THREE.MeshBasicMaterial({
        color: 0xaed3de,
        transparent: true,
        opacity: 0.22,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        side: THREE.DoubleSide
    })

    function addBox(parent, size, position, material = shellMaterial) {
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(...size), material)
        mesh.position.set(...position)
        mesh.receiveShadow = true
        parent.add(mesh)
        return mesh
    }

    function makeHologramMaterial(activeOpacity = 0.5, inactiveOpacity = 0.045, color = 0xb9e000) {
        const material = new THREE.MeshBasicMaterial({
            color,
            transparent: true,
            opacity: inactiveOpacity,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
            side: THREE.DoubleSide
        })
        material.userData.activeOpacity = activeOpacity
        material.userData.inactiveOpacity = inactiveOpacity
        return material
    }

    function makeAccentMaterial(chapter = 0) {
        const theme = chapterThemes[chapter] || chapterThemes[0]
        const inactiveColor = new THREE.Color(theme.accent).multiplyScalar(0.24)
        const material = new THREE.MeshPhysicalMaterial({
            color: inactiveColor,
            emissive: theme.accent,
            emissiveIntensity: 0.06,
            roughness: 0.22,
            metalness: 0.22,
            clearcoat: 0.92,
            clearcoatRoughness: 0.18,
            envMapIntensity: 1.12
        })
        material.userData.activeIntensity = 0.68
        material.userData.inactiveIntensity = 0.06
        material.userData.activeColor = new THREE.Color(theme.accent).multiplyScalar(0.78)
        material.userData.inactiveColor = inactiveColor
        return material
    }

    let brandMarkTexture

    function makeBrandMarkTexture() {
        if (brandMarkTexture) return brandMarkTexture
        brandMarkTexture = new THREE.TextureLoader().load(assetUrl('./img/logo-mark.webp'))
        brandMarkTexture.encoding = THREE.sRGBEncoding
        brandMarkTexture.anisotropy = renderer?.capabilities?.getMaxAnisotropy?.() || 1
        return brandMarkTexture
    }

    function makeAiBackdropTexture() {
        const aiCanvas = document.createElement('canvas')
        aiCanvas.width = 1024
        aiCanvas.height = 640
        const context = aiCanvas.getContext('2d')
        const background = context.createLinearGradient(0, 0, 1024, 640)
        background.addColorStop(0, '#071615')
        background.addColorStop(0.52, '#10242a')
        background.addColorStop(1, '#061013')
        context.fillStyle = background
        context.fillRect(0, 0, 1024, 640)

        context.strokeStyle = 'rgba(112,224,181,0.08)'
        context.lineWidth = 1
        for (let x = 48; x < 1024; x += 64) {
            context.beginPath()
            context.moveTo(x, 0)
            context.lineTo(x, 640)
            context.stroke()
        }
        for (let y = 32; y < 640; y += 64) {
            context.beginPath()
            context.moveTo(0, y)
            context.lineTo(1024, y)
            context.stroke()
        }

        const nodes = [
            [142, 154, 8], [268, 98, 11], [364, 226, 7], [506, 122, 14],
            [642, 208, 9], [798, 116, 12], [884, 254, 7], [210, 402, 12],
            [390, 472, 8], [528, 352, 18], [704, 452, 11], [866, 390, 8]
        ]
        const connections = [[0, 1], [0, 2], [1, 3], [2, 3], [2, 7], [3, 4], [3, 9], [4, 5], [4, 6], [4, 9], [5, 6], [6, 11], [7, 8], [8, 9], [9, 10], [10, 11]]
        connections.forEach(([from, to], index) => {
            const [fromX, fromY] = nodes[from]
            const [toX, toY] = nodes[to]
            const gradient = context.createLinearGradient(fromX, fromY, toX, toY)
            gradient.addColorStop(0, 'rgba(112,224,181,0.12)')
            gradient.addColorStop(0.5, index % 3 ? 'rgba(80,200,255,0.34)' : 'rgba(112,224,181,0.46)')
            gradient.addColorStop(1, 'rgba(112,224,181,0.12)')
            context.strokeStyle = gradient
            context.lineWidth = index % 4 === 0 ? 3 : 1.5
            context.beginPath()
            context.moveTo(fromX, fromY)
            context.lineTo(toX, toY)
            context.stroke()
        })
        nodes.forEach(([x, y, radius], index) => {
            const glow = context.createRadialGradient(x, y, 0, x, y, radius * 4.2)
            glow.addColorStop(0, index === 9 ? 'rgba(255,255,255,1)' : 'rgba(210,255,240,0.95)')
            glow.addColorStop(0.22, index % 3 ? 'rgba(80,200,255,0.68)' : 'rgba(112,224,181,0.78)')
            glow.addColorStop(1, 'rgba(112,224,181,0)')
            context.fillStyle = glow
            context.beginPath()
            context.arc(x, y, radius * 4.2, 0, Math.PI * 2)
            context.fill()
        })

        const texture = new THREE.CanvasTexture(aiCanvas)
        texture.encoding = THREE.sRGBEncoding
        texture.anisotropy = renderer?.capabilities?.getMaxAnisotropy?.() || 1
        return texture
    }

    function makeDataPanelTexture(chapter, eyebrow, value, detail = '') {
        const theme = chapterThemes[chapter] || chapterThemes[0]
        const panelCanvas = document.createElement('canvas')
        panelCanvas.width = 768
        panelCanvas.height = 432
        const context = panelCanvas.getContext('2d')
        const background = context.createLinearGradient(0, 0, 768, 432)
        background.addColorStop(0, '#091116')
        background.addColorStop(0.66, '#111a21')
        background.addColorStop(1, '#071015')
        context.fillStyle = background
        context.fillRect(0, 0, 768, 432)

        context.strokeStyle = theme.css
        context.globalAlpha = 0.82
        context.lineWidth = 5
        context.beginPath()
        context.moveTo(38, 42)
        context.lineTo(236, 42)
        context.stroke()
        context.globalAlpha = 0.15
        context.lineWidth = 1
        for (let x = 38; x < 740; x += 44) {
            context.beginPath()
            context.moveTo(x, 82)
            context.lineTo(x, 394)
            context.stroke()
        }
        for (let y = 86; y < 402; y += 42) {
            context.beginPath()
            context.moveTo(32, y)
            context.lineTo(736, y)
            context.stroke()
        }

        context.globalAlpha = 1
        context.fillStyle = theme.css
        context.font = '700 27px Arial, sans-serif'
        context.letterSpacing = '5px'
        context.fillText(eyebrow.toUpperCase(), 38, 92)
        context.fillStyle = '#f5f8f9'
        context.font = value.length > 12 ? '800 55px Arial, sans-serif' : '800 78px Arial, sans-serif'
        context.letterSpacing = '0px'
        context.fillText(value, 38, 196)
        context.fillStyle = '#9caab0'
        context.font = '500 25px Arial, sans-serif'
        context.fillText(detail, 40, 246)

        context.globalAlpha = 0.92
        context.fillStyle = theme.css
        ;[0.32, 0.58, 0.82].forEach((ratio, index) => {
            context.fillRect(40, 302 + index * 28, 650 * ratio, 8)
            context.globalAlpha *= 0.76
        })
        context.globalAlpha = 1
        context.fillStyle = '#7f8e94'
        context.font = '600 18px Arial, sans-serif'
        context.fillText(`RIEASE / NODE ${String(chapter).padStart(2, '0')}`, 40, 405)
        context.textAlign = 'right'
        context.fillStyle = theme.css
        context.fillText('ONLINE', 724, 405)

        const texture = new THREE.CanvasTexture(panelCanvas)
        texture.encoding = THREE.sRGBEncoding
        texture.anisotropy = renderer?.capabilities?.getMaxAnisotropy?.() || 1
        return texture
    }

    function addDataPanel(parent, chapter, data, position, size = [58, 34], rotation = [0, 0, 0]) {
        const panel = new THREE.Group()
        panel.position.set(...position)
        panel.rotation.set(...rotation)
        const frameMaterial = new THREE.MeshStandardMaterial({
            color: 0x111a20,
            roughness: 0.28,
            metalness: 0.74
        })
        const screenMaterial = new THREE.MeshBasicMaterial({
            map: makeDataPanelTexture(chapter, data.eyebrow, data.value, data.detail),
            color: 0xffffff,
            side: THREE.DoubleSide,
            toneMapped: false
        })
        addBox(panel, [size[0] + 5, size[1] + 5, 3.5], [0, 0, 0], frameMaterial)
        const screen = new THREE.Mesh(new THREE.PlaneGeometry(size[0], size[1]), screenMaterial)
        screen.position.z = -2
        screen.rotation.y = Math.PI
        screen.renderOrder = 3
        panel.add(screen)
        addBox(panel, [size[0] - 8, 1.3, 1.8], [0, -size[1] / 2 - 1.5, -2.4], makeAccentMaterial(chapter))
        parent.add(panel)
        return panel
    }

    function addCable(parent, points, color, radius = 0.7) {
        const curve = new THREE.CatmullRomCurve3(points.map((point) => new THREE.Vector3(...point)))
        const material = new THREE.MeshStandardMaterial({
            color: new THREE.Color(color).multiplyScalar(0.48),
            emissive: color,
            emissiveIntensity: 0.32,
            roughness: 0.34,
            metalness: 0.42
        })
        const cable = new THREE.Mesh(new THREE.TubeGeometry(curve, 30, radius, 6, false), material)
        parent.add(cable)
        return cable
    }

    // Circular floor and concentric guidance system make the seven rooms one journey.
    const outerFloor = new THREE.Mesh(new THREE.CylinderGeometry(610, 610, 12, 96), floorMaterial)
    outerFloor.position.copy(atriumCenter).setY(-5)
    outerFloor.receiveShadow = true
    pavilion.add(outerFloor)

    const innerFloor = new THREE.Mesh(new THREE.CylinderGeometry(425, 425, 3, 96), wallMaterial)
    innerFloor.position.copy(atriumCenter).setY(2)
    innerFloor.receiveShadow = true
    pavilion.add(innerFloor)

    ;[[176, 180], [322, 326], [506, 510]].forEach(([innerRadius, outerRadius], index) => {
        const material = limeLineMaterial.clone()
        material.opacity = 0.16 + index * 0.045
        const ring = new THREE.Mesh(new THREE.RingGeometry(innerRadius, outerRadius, 128), material)
        ring.position.copy(atriumCenter).setY(4.2 + index * 0.2)
        ring.rotation.x = -Math.PI / 2
        pavilion.add(ring)
    })

    // Faceted walls wrap the atrium while keeping a generous front entrance.
    for (let index = 0; index < 18; index += 1) {
        if ([8, 9, 10].includes(index)) continue
        const angle = (index / 18) * Math.PI * 2
        const x = atriumCenter.x + Math.sin(angle) * 574
        const z = atriumCenter.z + Math.cos(angle) * 574
        const panel = addBox(pavilion, [178, 254, 14], [x, 127, z], wallMaterial)
        panel.rotation.y = angle
        const inset = addBox(pavilion, [146, 208, 3], [x - Math.sin(angle) * 8, 126, z - Math.cos(angle) * 8], glassMaterial.clone())
        inset.rotation.y = angle
        const seam = addBox(pavilion, [118, 3, 4], [x - Math.sin(angle) * 11, 238, z - Math.cos(angle) * 11], architecturalLineMaterial.clone())
        seam.rotation.y = angle
        seam.material.opacity = 0.2
    }

    // Suspended rings and radial ribs give the room a strong silhouette from every camera.
    ;[350, 520].forEach((radius, index) => {
        const material = architecturalLineMaterial.clone()
        material.opacity = index === 0 ? 0.26 : 0.16
        const halo = new THREE.Mesh(new THREE.TorusGeometry(radius, index === 0 ? 2.4 : 1.4, 6, 128), material)
        halo.position.copy(atriumCenter).setY(278 + index * 7)
        halo.rotation.x = Math.PI / 2
        pavilion.add(halo)
    })
    for (let index = 0; index < 12; index += 1) {
        const angle = (index / 12) * Math.PI * 2
        const rib = addBox(
            pavilion,
            [8, 7, 500],
            [atriumCenter.x + Math.sin(angle) * 250, 278, atriumCenter.z + Math.cos(angle) * 250],
            shellMaterial
        )
        rib.rotation.y = angle
        const lightRib = addBox(
            pavilion,
            [2.5, 2, 356],
            [atriumCenter.x + Math.sin(angle) * 178, 273, atriumCenter.z + Math.cos(angle) * 178],
            architecturalLineMaterial.clone()
        )
        lightRib.rotation.y = angle
        lightRib.material.opacity = index % 2 ? 0.08 : 0.2
    }

    // The suspended R core acts as the landmark that keeps visitors oriented.
    const centralCore = new THREE.Group()
    centralCore.name = 'atrium-energy-core'
    centralCore.position.set(0, 205, 470)
    ;[54, 72, 92].forEach((radius, index) => {
        const material = makeHologramMaterial(0.54, 0.2 - index * 0.035)
        material.opacity = material.userData.inactiveOpacity
        const ring = new THREE.Mesh(new THREE.TorusGeometry(radius, index === 1 ? 2.4 : 1.2, 6, 96), material)
        ring.rotation.set(index * 0.52, index * 0.68, index * 0.28)
        ring.userData.kind = 'core-ring'
        ring.userData.speed = (index % 2 ? -1 : 1) * (0.00008 + index * 0.000025)
        animatedObjects.push(ring)
        centralCore.add(ring)
    })
    const coreGlow = new THREE.Mesh(new THREE.IcosahedronGeometry(23, 2), makeHologramMaterial(0.94, 0.72))
    coreGlow.userData.kind = 'core'
    animatedObjects.push(coreGlow)
    centralCore.add(coreGlow)
    const coreMark = new THREE.Sprite(new THREE.SpriteMaterial({
        map: makeBrandMarkTexture(),
        color: 0xb9e000,
        transparent: true,
        depthWrite: false
    }))
    coreMark.scale.set(82, 82, 1)
    coreMark.position.z = -5
    centralCore.add(coreMark)
    const coreBeam = new THREE.Mesh(
        new THREE.CylinderGeometry(8, 34, 210, 28, 1, true),
        makeHologramMaterial(0.12, 0.07)
    )
    coreBeam.position.y = -94
    centralCore.add(coreBeam)
    pavilion.add(centralCore)

    const zonePlacements = [
        [0, 0, 80],
        [1, -380, 220],
        [2, -410, 520],
        [3, -220, 820],
        [4, 220, 820],
        [5, 410, 520],
        [6, 380, 220]
    ]

    // The floor ribbon advances in the same clockwise order as the chapter navigation.
    const routePoints = zonePlacements.map(([, x, z]) => new THREE.Vector3(x, 6.5, z))
    const routeCurve = new THREE.CatmullRomCurve3(routePoints, false, 'catmullrom', 0.24)
    const routeMaterial = limeLineMaterial.clone()
    routeMaterial.opacity = 0.42
    const routeMesh = new THREE.Mesh(new THREE.TubeGeometry(routeCurve, 140, 2.2, 7, false), routeMaterial)
    pavilion.add(routeMesh)
    const routePulse = new THREE.Mesh(new THREE.SphereGeometry(7, 16, 12), makeHologramMaterial(0.98, 0.92))
    pavilion.add(routePulse)

    const particlePositions = new Float32Array(260 * 3)
    for (let index = 0; index < 260; index += 1) {
        const offset = index * 3
        const radius = 190 + Math.random() * 390
        const angle = Math.random() * Math.PI * 2
        particlePositions[offset] = Math.sin(angle) * radius
        particlePositions[offset + 1] = 24 + Math.random() * 235
        particlePositions[offset + 2] = 470 + Math.cos(angle) * radius
    }
    const particleGeometry = new THREE.BufferGeometry()
    particleGeometry.setAttribute('position', new THREE.BufferAttribute(particlePositions, 3))
    const particles = new THREE.Points(
        particleGeometry,
        new THREE.PointsMaterial({
            color: 0xb7d8e2,
            size: 1.35,
            transparent: true,
            opacity: 0.28,
            blending: THREE.AdditiveBlending,
            depthWrite: false
        })
    )
    pavilion.add(particles)

    function makeZone(chapter, x, z) {
        const theme = chapterThemes[chapter]
        const group = new THREE.Group()
        group.name = `cinematic-zone-${chapter}`
        group.position.set(x, 0, z)
        group.rotation.y = Math.atan2(x - atriumCenter.x, z - atriumCenter.z)
        group.userData.chapter = chapter
        group.userData.activation = 0
        group.userData.accentMaterials = []
        group.userData.hologramMaterials = []
        group.userData.labelMaterials = []
        group.userData.glowMaterials = []

        const accent = makeAccentMaterial(chapter)
        const hologram = makeHologramMaterial(0.48, 0.035, theme.accent)
        group.userData.accentMaterials.push(accent)
        group.userData.hologramMaterials.push(hologram)

        addBox(group, [226, 13, 126], [0, 6.5, 0], shellMaterial)
        addBox(group, [202, 3, 104], [0, 14.5, -2], accent)
        addBox(group, [10, 162, 10], [-112, 88, 35], shellMaterial)
        addBox(group, [10, 162, 10], [112, 88, 35], shellMaterial)
        addBox(group, [234, 10, 10], [0, 166, 35], shellMaterial)
        const backdropMaterial = new THREE.MeshStandardMaterial({
            color: 0xc7cfce,
            emissive: theme.accent,
            emissiveIntensity: 0.045,
            roughness: 0.68,
            metalness: 0.06,
            envMapIntensity: 0.42
        })
        atlasPanelMaterials[chapter] = backdropMaterial
        addBox(group, [210, 136, 3], [0, 92, 42], backdropMaterial)
        addBox(group, [172, 3, 6], [0, 154, 36], accent)

        const auraMaterial = new THREE.SpriteMaterial({
            map: glowTexture,
            color: theme.accent,
            transparent: true,
            opacity: 0.035,
            blending: THREE.AdditiveBlending,
            depthWrite: false,
            toneMapped: false
        })
        auraMaterial.userData.activeOpacity = 0.24
        auraMaterial.userData.inactiveOpacity = 0.035
        const aura = new THREE.Sprite(auraMaterial)
        aura.position.set(0, 94, 26)
        aura.scale.set(196, 196, 1)
        aura.renderOrder = 2
        group.userData.glowMaterials.push(auraMaterial)
        group.add(aura)

        const contactShadow = new THREE.Mesh(
            new THREE.PlaneGeometry(136, 82),
            new THREE.MeshBasicMaterial({
                map: glowTexture,
                color: 0x000000,
                transparent: true,
                opacity: 0.19,
                depthWrite: false,
                toneMapped: false
            })
        )
        contactShadow.rotation.x = -Math.PI / 2
        contactShadow.position.set(0, 16.2, -2)
        group.userData.contactShadow = contactShadow
        group.add(contactShadow)

        const floorRingMaterial = makeHologramMaterial(0.42, 0.025, theme.accent)
        group.userData.hologramMaterials.push(floorRingMaterial)
        const floorRing = new THREE.Mesh(new THREE.RingGeometry(84, 87, 72), floorRingMaterial)
        floorRing.rotation.x = -Math.PI / 2
        floorRing.position.set(0, 16.5, -2)
        floorRing.userData.baseScale = 1
        group.userData.floorRing = floorRing
        group.add(floorRing)

        const labelMaterial = new THREE.SpriteMaterial({
            map: makeZoneLabelTexture(chapterZoneData[chapter]),
            transparent: true,
            depthWrite: false,
            opacity: 0.035
        })
        labelMaterial.userData.activeOpacity = 0.92
        labelMaterial.userData.inactiveOpacity = 0.035
        const label = new THREE.Sprite(labelMaterial)
        label.position.set(0, 204, 34)
        label.scale.set(174, 61, 1)
        label.renderOrder = 4
        group.userData.labelMaterials.push(labelMaterial)
        group.add(label)

        const light = new THREE.PointLight(theme.light, 0.04, 260)
        light.position.set(0, 110, -30)
        group.userData.light = light
        group.add(light)

        const checkpointMaterial = makeHologramMaterial(0.92, 0.12, theme.accent)
        const checkpoint = new THREE.Mesh(new THREE.RingGeometry(15, 18, 40), checkpointMaterial)
        checkpoint.rotation.x = -Math.PI / 2
        checkpoint.position.set(0, 8.2, -76)
        checkpoint.userData.chapter = chapter
        routeCheckpoints.push(checkpoint)
        group.add(checkpoint)

        zoneGroups[chapter] = group
        pavilion.add(group)
        return { group, accent, hologram }
    }

    const zones = zonePlacements.map(([chapter, x, z]) => makeZone(chapter, x, z))

    atlasPanelMaterials[3].map = makeAiBackdropTexture()
    atlasPanelMaterials[3].color.set(0xd7eeee)
    atlasPanelMaterials[3].needsUpdate = true

    new THREE.TextureLoader().load(assetUrl('./img/exhibition-surface-atlas.jpg'), (atlasTexture) => {
        atlasTexture.encoding = THREE.sRGBEncoding
        atlasPanelMaterials.forEach((material, chapter) => {
            if (chapter === 3) return
            const atlasIndex = chapter > 3 ? chapter - 1 : chapter
            const tile = atlasTexture.clone()
            tile.needsUpdate = true
            tile.repeat.set(1 / 3, 1 / 2)
            tile.offset.set((atlasIndex % 3) / 3, atlasIndex < 3 ? 1 / 2 : 0)
            tile.wrapS = THREE.ClampToEdgeWrapping
            tile.wrapT = THREE.ClampToEdgeWrapping
            material.map = tile
            material.needsUpdate = true
        })
    })

    // 00 — layered gateway and rotating signal.
    {
        const { group, accent, hologram } = zones[0]
        const welcomePanels = [
            { eyebrow: 'GUIDE', value: 'RURU', detail: 'SMART TOUR READY' },
            { eyebrow: 'JOURNEY', value: '07', detail: 'CHAPTERS CONNECTED' }
        ]
        ;[-82, 82].forEach((x, index) => {
            addBox(group, [38, 66, 16], [x, 48, -18], shellMaterial)
            addDataPanel(group, 0, welcomePanels[index], [x, 55, -27.2], [29, 43])
            addBox(group, [42, 5, 26], [x, 19, -14], accent)
            ;[-8, 0, 8].forEach((offset, lightIndex) => {
                const light = addBox(group, [4, 2, 2], [x + offset, 27, -27.5], lightIndex === 1 ? accent : architecturalLineMaterial.clone())
                light.material.opacity = lightIndex === 1 ? 1 : 0.32
            })
        })
        ;[38, 53, 67].forEach((radius, index) => {
            const ringMaterial = makeHologramMaterial(index === 1 ? 0.86 : 0.54, 0.055, chapterThemes[0].accent)
            group.userData.hologramMaterials.push(ringMaterial)
            const ring = new THREE.Mesh(new THREE.TorusGeometry(radius, index === 1 ? 1.8 : 0.85, 7, 72), ringMaterial)
            ring.position.set(0, 91, 5 + index * 5)
            ring.rotation.y = (index - 1) * 0.23
            ring.userData.kind = 'portal-ring'
            ring.userData.chapter = 0
            ring.userData.speed = (index % 2 ? -1 : 1) * (0.00011 + index * 0.00003)
            animatedObjects.push(ring)
            group.add(ring)
        })
        const signal = new THREE.Group()
        signal.position.set(0, 91, -8)
        signal.userData.kind = 'zone-core'
        signal.userData.chapter = 0
        const signalMaterial = new THREE.MeshPhysicalMaterial({
            color: chapterThemes[0].accent,
            emissive: chapterThemes[0].accent,
            emissiveIntensity: 0.72,
            roughness: 0.18,
            metalness: 0.06,
            clearcoat: 0.92,
            clearcoatRoughness: 0.12,
            envMapIntensity: 1.2
        })
        const signalInner = new THREE.Mesh(new THREE.IcosahedronGeometry(13.5, 3), signalMaterial)
        signalInner.userData.kind = 'zone-core-inner'
        signal.add(signalInner)
        const signalShellMaterial = glassMaterial.clone()
        signalShellMaterial.color.set(chapterThemes[0].light)
        signalShellMaterial.emissive.set(chapterThemes[0].accent)
        signalShellMaterial.emissiveIntensity = 0.18
        signalShellMaterial.opacity = 0.42
        signalShellMaterial.transmission = 0.46
        signalShellMaterial.roughness = 0.1
        const signalShell = new THREE.Mesh(new THREE.SphereGeometry(18.5, 48, 32), signalShellMaterial)
        signal.add(signalShell)
        const signalMark = new THREE.Sprite(new THREE.SpriteMaterial({
            map: makeBrandMarkTexture(),
            color: 0xb9e000,
            transparent: true,
            opacity: 0.96,
            blending: THREE.AdditiveBlending,
            depthTest: false,
            depthWrite: false,
            toneMapped: false
        }))
        signalMark.position.set(0, 0, 0)
        signalMark.scale.set(20, 17.2, 1)
        signalMark.renderOrder = 6
        signal.add(signalMark)
        animatedObjects.push(signal)
        group.add(signal)
    }

    // 01 — an illuminated history skyline.
    {
        const { group, accent, hologram } = zones[1]
        const archivePaper = new THREE.MeshStandardMaterial({
            color: 0xe8dcc8,
            roughness: 0.9,
            metalness: 0.02
        })
        const archiveDesk = new THREE.MeshStandardMaterial({
            color: 0x574032,
            roughness: 0.72,
            metalness: 0.12
        })
        addBox(group, [188, 9, 44], [0, 25, -6], archiveDesk)
        for (let index = 0; index < 7; index += 1) {
            const folder = addBox(group, [18, 3.5, 25], [-69 + index * 23, 32 + (index % 2) * 1.6, -8], archivePaper)
            folder.rotation.y = (index - 3) * 0.025
            addBox(group, [11, 0.8, 1.2], [folder.position.x, folder.position.y + 2.2, -21], index % 2 ? accent : architecturalLineMaterial.clone())
        }
        const heights = [44, 70, 102, 132, 158]
        heights.forEach((height, index) => {
            const tower = addBox(group, [21, height, 24], [-64 + index * 32, 18 + height / 2, -4], wallMaterial)
            tower.userData.kind = 'timeline-tower'
            tower.userData.chapter = 1
            tower.userData.baseY = tower.position.y
            tower.userData.phase = index * 0.55
            animatedObjects.push(tower)
            const crown = addBox(group, [29, 3, 32], [tower.position.x, 20 + height, -4], hologram)
            crown.userData.kind = 'timeline-crown'
            crown.userData.chapter = 1
            crown.userData.phase = index * 0.55
            animatedObjects.push(crown)
        })
        ;[
            { x: -68, y: 63, eyebrow: 'FOUNDED', value: '2009', detail: 'TAOYUAN' },
            { x: 0, y: 52, eyebrow: 'EXPERIENCE', value: '25+', detail: 'YEARS' },
            { x: 68, y: 63, eyebrow: 'DELIVERY', value: '1000+', detail: 'PROJECTS' }
        ].forEach((metric, index) => {
            addBox(group, [4, metric.y - 17, 4], [metric.x, (metric.y - 17) / 2 + 17, -23], archiveDesk)
            addDataPanel(group, 1, metric, [metric.x, metric.y, -25.5], [47, 27], [0, (index - 1) * 0.08, 0])
        })
        addCable(group, [[-68, 17, -21], [-30, 15, -28], [0, 17, -24], [68, 17, -21]], chapterThemes[1].accent, 0.55)
    }

    // 02 — a six-node capability reactor.
    {
        const { group, accent, hologram } = zones[2]
        const deviceFrame = new THREE.MeshStandardMaterial({
            color: 0x182a36,
            roughness: 0.3,
            metalness: 0.68
        })
        const servicePanels = [
            { eyebrow: '01 / 02', value: 'WEB + APP', detail: 'EXPERIENCE LAYER' },
            { eyebrow: '03 / 04', value: 'CONNECT', detail: 'DATA & TRANSFORM' },
            { eyebrow: '05 / 06', value: 'SECURE', detail: 'PROTECT & OPERATE' }
        ]
        ;[-74, 0, 74].forEach((x, index) => {
            const panelY = 43 + (index % 2) * 7
            addBox(group, [52, 42, 8], [x, panelY, -8], deviceFrame)
            addDataPanel(group, 2, servicePanels[index], [x, panelY + 1, -13.2], [43, 30], [0, (index - 1) * -0.1, 0])
            addBox(group, [5, 22, 5], [x, 19, -4], deviceFrame)
            addBox(group, [22, 3, 10], [x, 16, -4], accent)
            addCable(group, [[x, 30, -1], [x * 0.72, 47, 4], [x * 0.42, 64, 1], [0, 72, 0]], chapterThemes[2].accent, 0.62)
        })
        const reactor = new THREE.Group()
        reactor.position.set(0, 92, 0)
        reactor.userData.kind = 'reactor'
        reactor.userData.chapter = 2
        animatedObjects.push(reactor)
        const orbit = new THREE.Mesh(new THREE.TorusGeometry(58, 1.1, 6, 80), hologram)
        reactor.add(orbit)
        for (let index = 0; index < 6; index += 1) {
            const angle = (index / 6) * Math.PI * 2
            const node = new THREE.Mesh(new THREE.CylinderGeometry(7, 7, 6, 18), accent)
            node.position.set(Math.cos(angle) * 58, Math.sin(angle) * 58, 0)
            node.rotation.x = Math.PI / 2
            node.rotation.z = angle
            reactor.add(node)
            addCable(
                reactor,
                [[0, 0, -1], [Math.cos(angle) * 28, Math.sin(angle) * 28, -1], [Math.cos(angle) * 51, Math.sin(angle) * 51, 0]],
                chapterThemes[2].accent,
                0.42
            )
        }
        const hub = new THREE.Mesh(new THREE.SphereGeometry(19, 28, 18), accent)
        reactor.add(hub)
        const hubShellMaterial = glassMaterial.clone()
        hubShellMaterial.color.set(chapterThemes[2].accent)
        hubShellMaterial.emissive.set(chapterThemes[2].accent)
        hubShellMaterial.emissiveIntensity = 0.12
        hubShellMaterial.opacity = 0.2
        const hubShell = new THREE.Mesh(new THREE.SphereGeometry(27, 32, 22), hubShellMaterial)
        reactor.add(hubShell)
        group.add(reactor)
    }

    // 03 — an AI orchestration core connects four practical workflow modules.
    {
        const { group, accent, hologram } = zones[3]
        const aiFrameMaterial = new THREE.MeshStandardMaterial({
            color: 0x112522,
            emissive: 0x173d34,
            emissiveIntensity: 0.2,
            roughness: 0.3,
            metalness: 0.46,
            envMapIntensity: 0.96
        })
        const aiModules = [
            { x: -76, y: 55, eyebrow: '01 / SERVICE', value: 'LINE AI', detail: 'HUMAN HANDOFF' },
            { x: 76, y: 55, eyebrow: '02 / DOCUMENT', value: 'DOC AI', detail: 'DRAFT & REVIEW' },
            { x: -76, y: 112, eyebrow: '03 / WORKFLOW', value: 'AUTOMATE', detail: 'SYSTEM CONNECT' },
            { x: 76, y: 112, eyebrow: '04 / INSIGHT', value: 'ASK DATA', detail: 'TREND & ALERT' }
        ]
        aiModules.forEach((module, index) => {
            addBox(group, [54, 38, 8], [module.x, module.y, -4], aiFrameMaterial)
            addDataPanel(group, 3, module, [module.x, module.y + 1, -9], [46, 30], [0, module.x < 0 ? -0.08 : 0.08, 0])
            addBox(group, [5, module.y - 17, 5], [module.x, 17 + (module.y - 17) / 2, 0], aiFrameMaterial)
            addBox(group, [22, 3, 10], [module.x, 16, 0], index % 2 ? accent : hologram)
            addCable(
                group,
                [[module.x, 20, -6], [module.x * 0.7, 36 + index * 4, -10], [module.x * 0.34, 67 + index * 2, -7], [0, 88, -4]],
                chapterThemes[3].accent,
                0.48
            )
        })

        const aiCore = new THREE.Group()
        aiCore.position.set(0, 91, -1)
        aiCore.userData.kind = 'ai-core'
        aiCore.userData.chapter = 3
        aiCore.userData.baseY = aiCore.position.y
        const aiInnerMaterial = new THREE.MeshPhysicalMaterial({
            color: chapterThemes[3].accent,
            emissive: chapterThemes[3].accent,
            emissiveIntensity: 0.78,
            roughness: 0.2,
            metalness: 0.05,
            clearcoat: 0.9,
            clearcoatRoughness: 0.14,
            envMapIntensity: 1.24
        })
        const aiInner = new THREE.Mesh(new THREE.IcosahedronGeometry(18, 2), aiInnerMaterial)
        aiCore.add(aiInner)
        const aiShellMaterial = glassMaterial.clone()
        aiShellMaterial.color.set(0xb8ffe6)
        aiShellMaterial.emissive.set(chapterThemes[3].accent)
        aiShellMaterial.emissiveIntensity = 0.16
        aiShellMaterial.opacity = 0.3
        aiShellMaterial.transmission = 0.5
        const aiShell = new THREE.Mesh(new THREE.IcosahedronGeometry(27, 3), aiShellMaterial)
        aiCore.add(aiShell)
        ;[
            [38, 0.9, [Math.PI / 2, 0, 0]],
            [48, 0.62, [0.28, 0.42, 0.68]]
        ].forEach(([radius, tube, rotation], index) => {
            const orbitMaterial = hologram.clone()
            orbitMaterial.opacity = 0.46 - index * 0.12
            const orbit = new THREE.Mesh(new THREE.TorusGeometry(radius, tube, 7, 72), orbitMaterial)
            orbit.rotation.set(...rotation)
            aiCore.add(orbit)
        })
        for (let index = 0; index < 10; index += 1) {
            const angle = (index / 10) * Math.PI * 2
            const altitude = Math.sin(index * 1.7) * 14
            const radius = 36 + (index % 2) * 8
            const node = new THREE.Mesh(new THREE.SphereGeometry(index % 3 ? 2.4 : 3.6, 14, 10), index % 3 ? accent : hologram)
            node.position.set(Math.cos(angle) * radius, altitude, Math.sin(angle) * radius)
            node.userData.phase = angle
            aiCore.add(node)
        }
        animatedObjects.push(aiCore)
        group.add(aiCore)
    }

    // 04 — six full-height gates create a real forward process tunnel.
    {
        const { group, accent, hologram } = zones[4]
        const worktop = new THREE.MeshStandardMaterial({
            color: 0x7a4939,
            roughness: 0.76,
            metalness: 0.06
        })
        addBox(group, [176, 8, 42], [0, 25, 8], worktop)
        const workflowSteps = [
            ['01', 'DISCOVER', 'GOALS & USERS'],
            ['02', 'PLAN', 'SCOPE & SYSTEM'],
            ['03', 'DESIGN', 'UI / UX PROTOTYPE'],
            ['04', 'BUILD', 'AGILE DELIVERY'],
            ['05', 'TEST', 'QUALITY & SECURITY'],
            ['06', 'CARE', 'LAUNCH & SUPPORT']
        ]
        workflowSteps.forEach(([eyebrow, value, detail], index) => {
            const column = index % 3
            const row = Math.floor(index / 3)
            const x = 58 - column * 58
            const y = 84 - row * 35
            addBox(group, [3, y - 28, 3], [x, 28 + (y - 28) / 2, -14], shellMaterial)
            addDataPanel(group, 4, { eyebrow, value, detail }, [x, y, -17], [48, 25], [0, (column - 1) * -0.055, 0])
        })
        addCable(group, [[-79, 17, -17], [-38, 14, -23], [0, 16, -20], [38, 14, -23], [79, 17, -17]], chapterThemes[4].accent, 0.54)
        for (let index = 0; index < 6; index += 1) {
            const depth = -54 + index * 25
            const width = 190 - index * 14
            const height = 148 - index * 6
            const material = index === 5 ? accent : (index % 2 ? hologram : shellMaterial)
            const arch = new THREE.Group()
            arch.position.z = depth
            arch.userData.kind = 'process-arch'
            arch.userData.chapter = 4
            arch.userData.phase = index * 0.42
            addBox(arch, [4, height, 4], [-width / 2, 18 + height / 2, 0], material)
            addBox(arch, [4, height, 4], [width / 2, 18 + height / 2, 0], material)
            addBox(arch, [width + 4, 4, 4], [0, 18 + height, 0], material)
            animatedObjects.push(arch)
            group.add(arch)
        }
    }

    // 05 — a faceted vault with a moving security scan.
    {
        const { group, accent, hologram } = zones[5]
        const serverMaterial = new THREE.MeshStandardMaterial({
            color: 0x172332,
            emissive: 0x101e36,
            emissiveIntensity: 0.16,
            roughness: 0.34,
            metalness: 0.72
        })
        const serverLight = new THREE.MeshBasicMaterial({ color: 0x8ab7ff })
        ;[-72, 72].forEach((x) => {
            addBox(group, [42, 108, 28], [x, 73, 0], serverMaterial)
            addBox(group, [36, 5, 30], [x, 128, 0], accent)
            for (let index = 0; index < 8; index += 1) {
                const rowY = 34 + index * 12
                addBox(group, [32, 5, 2.5], [x, rowY, -15.2], shellMaterial)
                addBox(group, [14, 0.9, 1.2], [x - 6, rowY, -17], architecturalLineMaterial.clone())
                ;[9, 13].forEach((offset, ledIndex) => {
                    addBox(group, [1.6, 1.6, 1.3], [x + offset, rowY, -17], (index + ledIndex) % 3 ? serverLight : accent)
                })
            }
            addBox(group, [3, 45, 3], [x + 15, 73, -17], architecturalLineMaterial.clone())
        })
        addDataPanel(group, 5, { eyebrow: 'COMPLIANCE', value: 'ISO 27001', detail: 'VERIFIED SECURITY SYSTEM' }, [0, 98, -13], [72, 41])
        ;[-72, 72].forEach((x, index) => {
            addDataPanel(
                group,
                5,
                index ? { eyebrow: 'BACKUP', value: '3-2-1', detail: 'RECOVERY READY' } : { eyebrow: 'MONITOR', value: '24 / 7', detail: 'ACTIVE WATCH' },
                [x, 151, -8],
                [43, 24]
            )
        })
        const vault = new THREE.Mesh(new THREE.RingGeometry(49, 55, 12), hologram)
        vault.position.set(0, 94, 1)
        vault.userData.kind = 'vault'
        vault.userData.chapter = 5
        animatedObjects.push(vault)
        group.add(vault)
        const lockCore = new THREE.Mesh(new THREE.CylinderGeometry(12, 12, 8, 32), accent)
        lockCore.position.set(0, 94, -10)
        lockCore.rotation.x = Math.PI / 2
        group.add(lockCore)
        const lockRing = new THREE.Mesh(new THREE.TorusGeometry(17, 1.5, 8, 36), hologram)
        lockRing.position.set(0, 94, -15)
        group.add(lockRing)
        addCable(group, [[-72, 19, -15], [-38, 18, -22], [0, 23, -19], [38, 18, -22], [72, 19, -15]], chapterThemes[5].accent, 0.58)
        const scanMaterial = makeHologramMaterial(0.52, 0.03, chapterThemes[5].accent)
        group.userData.hologramMaterials.push(scanMaterial)
        const scan = new THREE.Mesh(new THREE.PlaneGeometry(150, 4), scanMaterial)
        scan.position.set(0, 40, -14)
        scan.userData.kind = 'security-scan'
        scan.userData.chapter = 5
        animatedObjects.push(scan)
        group.add(scan)
    }

    // 06 — a digital-twin console turns the final room into a working project lab.
    {
        const { group, accent, hologram } = zones[6]
        const consoleMaterial = new THREE.MeshStandardMaterial({
            color: 0x241d2d,
            emissive: chapterThemes[6].accent,
            emissiveIntensity: 0.1,
            roughness: 0.3,
            metalness: 0.58,
            envMapIntensity: 1.08
        })
        const glassTopMaterial = new THREE.MeshPhysicalMaterial({
            color: 0x533d60,
            emissive: chapterThemes[6].accent,
            emissiveIntensity: 0.14,
            transparent: true,
            opacity: 0.52,
            roughness: 0.12,
            metalness: 0.08,
            transmission: 0.32,
            clearcoat: 0.9,
            clearcoatRoughness: 0.14,
            envMapIntensity: 1.32,
            side: THREE.DoubleSide
        })

        const consoleBase = new THREE.Mesh(new THREE.CylinderGeometry(91, 98, 15, 64), consoleMaterial)
        consoleBase.position.set(0, 25, 1)
        consoleBase.receiveShadow = true
        group.add(consoleBase)
        const consoleTop = new THREE.Mesh(new THREE.CylinderGeometry(88, 88, 4, 64), glassTopMaterial)
        consoleTop.position.set(0, 34, 1)
        group.add(consoleTop)
        const consoleEdge = new THREE.Mesh(new THREE.TorusGeometry(89, 1.5, 8, 96), accent)
        consoleEdge.position.set(0, 36.5, 1)
        consoleEdge.rotation.x = Math.PI / 2
        group.add(consoleEdge)
        ;[-58, -29, 0, 29, 58].forEach((x, index) => {
            addBox(group, [18, 4, 3], [x, 24, -90.5], index === 2 ? accent : architecturalLineMaterial.clone())
        })

        function addTwinCluster(originX, mirrored = false) {
            const cluster = new THREE.Group()
            cluster.position.set(originX, 0, 2)
            const direction = mirrored ? -1 : 1
            addBox(cluster, [47, 5, 38], [0, 39, 0], consoleMaterial)
            addBox(cluster, [42, 1.4, 33], [0, 42, -1], glassTopMaterial)
            const buildings = [
                [-14, -7, 10, 27, 9],
                [-2, 4, 8, 42, 8],
                [12, -5, 11, 33, 10],
                [15, 8, 6, 19, 7],
                [-13, 9, 7, 17, 7]
            ]
            buildings.forEach(([x, z, width, height, depth], index) => {
                const building = addBox(cluster, [width, height, depth], [x * direction, 43 + height / 2, z], consoleMaterial)
                building.material = consoleMaterial.clone()
                building.material.emissiveIntensity = 0.06 + index * 0.018
                for (let row = 0; row < Math.max(2, Math.floor(height / 10)); row += 1) {
                    addBox(
                        cluster,
                        [Math.max(3, width - 3), 0.8, 0.7],
                        [x * direction, 49 + row * 8, z - depth / 2 - 0.45],
                        row % 3 === index % 3 ? accent : architecturalLineMaterial.clone()
                    )
                }
            })
            const mast = addBox(cluster, [2, 46, 2], [19 * direction, 65, 10], consoleMaterial)
            addBox(cluster, [13, 1.2, 1.2], [19 * direction, 88, 10], accent).rotation.y = mirrored ? -0.32 : 0.32
            addBox(cluster, [5, 2, 5], [19 * direction, 91, 10], accent)
            mast.rotation.z = direction * 0.02
            group.add(cluster)
        }

        addTwinCluster(-60)
        addTwinCluster(60, true)

        addDataPanel(
            group,
            6,
            { eyebrow: 'PROJECT LAB', value: 'YOUR NEXT', detail: 'DISCOVER / PROTOTYPE / LAUNCH' },
            [0, 54, -84],
            [58, 31],
            [-0.12, 0, 0]
        )
        addDataPanel(
            group,
            6,
            { eyebrow: 'DIGITAL TWIN', value: 'LIVE', detail: 'SYSTEM MODEL' },
            [-74, 69, -50],
            [43, 25],
            [-0.08, -0.34, -0.04]
        )
        addDataPanel(
            group,
            6,
            { eyebrow: 'READINESS', value: '96%', detail: 'LAUNCH SIGNAL' },
            [74, 69, -50],
            [43, 25],
            [-0.08, 0.34, 0.04]
        )

        addCable(group, [[-60, 40, 3], [-39, 39, -6], [-22, 47, -1], [0, 52, 1]], chapterThemes[6].accent, 0.68)
        addCable(group, [[60, 40, 3], [39, 39, -6], [22, 47, -1], [0, 52, 1]], chapterThemes[6].accent, 0.68)
        addCable(group, [[-74, 38, -48], [-50, 29, -69], [0, 27, -82], [50, 29, -69], [74, 38, -48]], chapterThemes[6].accent, 0.52)

        const corePedestal = new THREE.Mesh(new THREE.CylinderGeometry(23, 29, 32, 32), consoleMaterial)
        corePedestal.position.set(0, 52, 1)
        group.add(corePedestal)
        for (let index = 0; index < 5; index += 1) {
            const portAngle = (index / 5) * Math.PI * 2
            const port = new THREE.Mesh(new THREE.CylinderGeometry(2.3, 2.3, 4, 12), accent)
            port.position.set(Math.cos(portAngle) * 27, 62, 1 + Math.sin(portAngle) * 27)
            port.rotation.z = Math.PI / 2
            group.add(port)
        }

        const core = new THREE.Group()
        core.position.set(0, 91, 1)
        core.userData.kind = 'future-console-core'
        core.userData.chapter = 6
        core.userData.baseY = core.position.y
        animatedObjects.push(core)

        const coreGlass = new THREE.Mesh(new THREE.SphereGeometry(15, 32, 24), glassTopMaterial)
        core.add(coreGlass)
        const coreShellMaterial = glassTopMaterial.clone()
        coreShellMaterial.opacity = 0.24
        coreShellMaterial.roughness = 0.08
        const coreShell = new THREE.Mesh(new THREE.SphereGeometry(20, 36, 28), coreShellMaterial)
        core.add(coreShell)
        const innerSignal = new THREE.Mesh(new THREE.SphereGeometry(7, 24, 16), accent)
        core.add(innerSignal)
        ;[
            [27, 0.95, [Math.PI / 2, 0, 0], 0.0028],
            [34, 0.72, [0.25, 0.38, 0], -0.0021],
            [42, 0.58, [-0.34, 0.16, 0.72], 0.0016]
        ].forEach(([radius, tube, rotation, speed], index) => {
            const orbitMaterial = hologram.clone()
            orbitMaterial.opacity = 0.24 - index * 0.04
            const orbit = new THREE.Mesh(new THREE.TorusGeometry(radius, tube, 7, 64, Math.PI * (1.22 + index * 0.16)), orbitMaterial)
            orbit.rotation.set(...rotation)
            orbit.userData.kind = 'future-orbit'
            orbit.userData.chapter = 6
            orbit.userData.speed = speed
            orbit.userData.phase = index * 0.7
            animatedObjects.push(orbit)
            core.add(orbit)
        })
        for (let index = 0; index < 8; index += 1) {
            const angle = (index / 8) * Math.PI * 2
            const node = new THREE.Mesh(new THREE.CylinderGeometry(2.8, 2.8, 3.5, 14), index % 3 ? accent : glassTopMaterial)
            node.position.set(Math.cos(angle) * 35, Math.sin(angle) * 13, Math.sin(angle) * 35)
            node.rotation.set(angle * 0.4, angle, Math.PI / 2)
            core.add(node)
        }
        group.add(core)
    }

    setActiveArchitectureZone = (chapter) => {
        activeZone = Math.max(0, Math.min(chapter, zoneGroups.length - 1))
    }

    updateArchitecture = (timestamp) => {
        const time = timestamp * 0.001
        particles.rotation.y = Math.sin(time * 0.08) * 0.08
        particles.position.y = Math.sin(time * 0.3) * 3
        routePulse.position.copy(routeCurve.getPointAt((time * 0.035) % 1))
        routePulse.position.y += 3 + Math.sin(time * 4) * 2

        zoneGroups.forEach((group, chapter) => {
            const isActive = chapter === activeZone
            group.userData.activation = THREE.MathUtils.lerp(group.userData.activation, isActive ? 1 : 0, 0.07)
            const activation = group.userData.activation
            const scale = 1 + activation * 0.035
            group.scale.setScalar(scale)
            group.position.y = activation * 3

            group.userData.accentMaterials.forEach((material) => {
                material.emissiveIntensity = THREE.MathUtils.lerp(
                    material.userData.inactiveIntensity,
                    material.userData.activeIntensity,
                    activation
                )
                material.color.lerpColors(material.userData.inactiveColor, material.userData.activeColor, activation)
            })
            group.userData.hologramMaterials.forEach((material) => {
                material.opacity = THREE.MathUtils.lerp(
                    material.userData.inactiveOpacity,
                    material.userData.activeOpacity,
                    activation
                )
            })
            group.userData.labelMaterials.forEach((material) => {
                material.opacity = THREE.MathUtils.lerp(
                    material.userData.inactiveOpacity,
                    material.userData.activeOpacity,
                    activation
                )
            })
            group.userData.glowMaterials.forEach((material) => {
                material.opacity = THREE.MathUtils.lerp(
                    material.userData.inactiveOpacity,
                    material.userData.activeOpacity,
                    activation
                )
            })
            group.userData.contactShadow.material.opacity = THREE.MathUtils.lerp(0.11, 0.26, activation)
            group.userData.light.intensity = THREE.MathUtils.lerp(0.025, 0.68, activation)
            const ringPulse = 1 + activation * (0.08 + Math.sin(time * 2.5) * 0.025)
            group.userData.floorRing.scale.setScalar(ringPulse)
        })

        routeCheckpoints.forEach((checkpoint) => {
            const passed = checkpoint.userData.chapter <= activeZone
            checkpoint.material.opacity = THREE.MathUtils.lerp(checkpoint.material.opacity, passed ? 0.76 : 0.12, 0.08)
            checkpoint.rotation.z += passed ? 0.0025 : 0.0004
        })

        animatedObjects.forEach((object) => {
            const isZoneActive = object.userData.chapter === undefined || object.userData.chapter === activeZone
            if (object.userData.kind === 'core-ring') {
                object.rotation.z += object.userData.speed
                object.rotation.y -= object.userData.speed * 0.55
            } else if (object.userData.kind === 'core') {
                object.rotation.x = time * 0.28
                object.rotation.y = time * 0.42
                object.scale.setScalar(1 + Math.sin(time * 1.6) * 0.08)
            } else if (!isZoneActive) {
                return
            } else if (object.userData.kind === 'portal-ring') {
                object.rotation.z += object.userData.speed
                object.rotation.y += object.userData.speed * 0.48
            } else if (object.userData.kind === 'zone-core') {
                object.rotation.x = time * 0.7
                object.rotation.y = time * 0.95
                const corePulse = 1 + Math.sin(time * 2.1) * 0.045
                object.scale.setScalar(corePulse)
            } else if (object.userData.kind === 'timeline-tower') {
                object.position.y = object.userData.baseY + Math.sin(time * 1.8 + object.userData.phase) * 2
            } else if (object.userData.kind === 'timeline-crown') {
                object.rotation.y = time * 0.45 + object.userData.phase
            } else if (object.userData.kind === 'reactor') {
                object.rotation.z = time * 0.3
                object.rotation.y = Math.sin(time * 0.55) * 0.32
            } else if (object.userData.kind === 'ai-core') {
                object.position.y = object.userData.baseY + Math.sin(time * 1.35) * 3
                object.rotation.y = time * 0.26
                object.rotation.z = Math.sin(time * 0.72) * 0.08
            } else if (object.userData.kind === 'process-arch') {
                const pulse = 1 + Math.max(0, Math.sin(time * 2.2 - object.userData.phase)) * 0.025
                object.scale.set(pulse, pulse, 1)
            } else if (object.userData.kind === 'vault') {
                object.rotation.z = Math.sin(time * 0.42) * 0.16
            } else if (object.userData.kind === 'security-scan') {
                object.position.y = 42 + ((time * 32) % 108)
            } else if (object.userData.kind === 'future-console-core') {
                object.position.y = object.userData.baseY + Math.sin(time * 1.15) * 2.4
                object.rotation.y = Math.sin(time * 0.48) * 0.16
            } else if (object.userData.kind === 'future-orbit') {
                object.rotation.z += object.userData.speed
                object.rotation.y += object.userData.speed * 0.42
            }
        })
    }

    setActiveArchitectureZone(0)
}

function createEnvironment() {
    scene.fog = new THREE.Fog(0x070b0d, 1180, 2250)
    const floorGeometry = new THREE.PlaneBufferGeometry(4500, 4500)
    const floorMaterial = new THREE.MeshStandardMaterial({
        color: 0x111719,
        roughness: 0.94,
        metalness: 0.04,
        side: THREE.DoubleSide
    })
    const floor = new THREE.Mesh(floorGeometry, floorMaterial)
    floor.name = 'floor'
    floor.rotation.x = -Math.PI / 2
    floor.position.set(10, -2.5, -5)
    floor.receiveShadow = true
    scene.add(floor)

    const hemisphereLight = new THREE.HemisphereLight(0xc9dded, 0x101416, 0.2)
    scene.add(hemisphereLight)

    const ambientLight = new THREE.AmbientLight(0x9aa8af, 0.11)
    scene.add(ambientLight)

    const keyLight = new THREE.SpotLight(0xe8f3f7, 0.48, 1250, 0.66, 0.82, 1.2)
    keyLight.position.set(-260, 420, -80)
    keyLight.target.position.set(0, 115, 510)
    keyLight.castShadow = true
    keyLight.shadow.mapSize.set(...(window.innerWidth <= 820 ? [1024, 1024] : [2048, 2048]))
    keyLight.shadow.camera.near = 30
    keyLight.shadow.camera.far = 1200
    scene.add(keyLight, keyLight.target)

    const accentLight = new THREE.SpotLight(0xaed500, 0.2, 880, 0.58, 0.9, 1.4)
    accentLight.position.set(320, 300, -10)
    accentLight.target.position.set(30, 150, 590)
    scene.add(accentLight, accentLight.target)

    const fillLight = new THREE.PointLight(0xbfd8ff, 0.16, 620)
    fillLight.position.set(-330, 145, 170)
    scene.add(fillLight)

    const guideLight = new THREE.SpotLight(0xcfe5ff, 0.28, 680, 0.5, 0.94, 1.3)
    guideLight.position.set(-90, 260, -30)
    guideLight.target.position.set(250, 55, 300)
    scene.add(guideLight, guideLight.target)

    /* 空氣中的漂浮微粒：兩層以不同速度緩慢旋轉，給空間深度與生命感 */
    const dustLayers = [0.006, -0.0042].map((speed, layerIndex) => {
        const count = 150
        const positions = new Float32Array(count * 3)
        for (let index = 0; index < count; index += 1) {
            positions[index * 3] = (Math.random() - 0.5) * 820
            positions[index * 3 + 1] = 14 + Math.random() * 300
            positions[index * 3 + 2] = (Math.random() - 0.5) * 860
        }
        const geometry = new THREE.BufferGeometry()
        geometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
        const material = new THREE.PointsMaterial({
            color: layerIndex === 0 ? 0xcfe0b8 : 0x9fc4d8,
            size: layerIndex === 0 ? 2.4 : 1.7,
            sizeAttenuation: true,
            transparent: true,
            opacity: 0.22,
            blending: THREE.AdditiveBlending,
            depthWrite: false
        })
        const points = new THREE.Points(geometry, material)
        points.name = `ambient-dust-${layerIndex}`
        points.position.set(0, 0, 280)
        points.userData.speed = speed
        scene.add(points)
        return points
    })

    updateAmbientParticles = (timestamp) => {
        if (prefersReducedMotion) return
        const time = timestamp * 0.001
        dustLayers.forEach((layer, index) => {
            layer.rotation.y = time * layer.userData.speed
            layer.position.y = Math.sin(time * 0.11 + index * 2.1) * 5
        })
    }

    createExhibitionScreen()
    createExperienceArchitecture()
}

function createStudioEnvironmentMap() {
    if (!renderer) return
    const environmentScene = new THREE.Scene()
    environmentScene.background = new THREE.Color(0x071014)

    const room = new THREE.Mesh(
        new THREE.BoxGeometry(90, 64, 90),
        new THREE.MeshBasicMaterial({ color: 0x0b1519, side: THREE.BackSide })
    )
    environmentScene.add(room)

    function addLightPanel(size, position, rotation, color, intensity = 1) {
        const panelColor = new THREE.Color(color).multiplyScalar(intensity)
        const panel = new THREE.Mesh(
            new THREE.PlaneGeometry(size[0], size[1]),
            new THREE.MeshBasicMaterial({ color: panelColor, side: THREE.DoubleSide })
        )
        panel.position.set(...position)
        panel.rotation.set(...rotation)
        environmentScene.add(panel)
    }

    addLightPanel([34, 15], [0, 19, -41], [0, 0, 0], 0xe9f6ff, 1.05)
    addLightPanel([22, 30], [-42, 2, -8], [0, Math.PI / 2, 0], 0x8fcfff, 0.72)
    addLightPanel([24, 25], [42, 5, 12], [0, -Math.PI / 2, 0], 0xe8c98f, 0.68)
    addLightPanel([40, 18], [0, 30, 4], [Math.PI / 2, 0, 0], 0xffffff, 0.82)
    addLightPanel([26, 12], [8, -28, 4], [-Math.PI / 2, 0, 0], 0x4d7480, 0.34)

    const pmremGenerator = new THREE.PMREMGenerator(renderer)
    const environmentTarget = pmremGenerator.fromScene(environmentScene, 0.04, 0.1, 100)
    scene.environment = environmentTarget.texture
    pmremGenerator.dispose()
    environmentScene.traverse((object) => {
        object.geometry?.dispose?.()
        object.material?.dispose?.()
    })
}

function setupRendererAndCamera() {
    const viewport = exhibitionRoot.getBoundingClientRect()
    const viewportWidth = Math.max(viewport.width, 1)
    const viewportHeight = Math.max(viewport.height, 1)

    camera = new THREE.PerspectiveCamera(
        getResponsiveCameraFov(viewportWidth, viewportHeight),
        viewportWidth / viewportHeight,
        6,
        4000
    )
    camera.position.set(-300, 3065, -400)
    scene.add(camera)

    renderer = new THREE.WebGLRenderer({
        logarithmicDepthBuffer: true,
        antialias: true,
        stencil: false,
        alpha: true,
        canvas,
        powerPreference: 'high-performance'
    })
    renderer.setSize(viewportWidth, viewportHeight, false)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, viewportWidth <= 820 ? 1.35 : 1.65))
    renderer.setClearColor(0x070a0d, 1)
    renderer.shadowMap.enabled = true
    renderer.shadowMap.type = THREE.PCFSoftShadowMap
    renderer.outputEncoding = THREE.sRGBEncoding
    renderer.toneMapping = THREE.ACESFilmicToneMapping
    renderer.toneMappingExposure = 0.68
    createStudioEnvironmentMap()

    controls = new THREE.OrbitControls(camera, renderer.domElement)
    controls.enableZoom = !isHomeExperience
    controls.enablePan = false
    controls.enableDamping = true
    controls.dampingFactor = 0.1
    controls.maxDistance = 920
    controls.minDistance = 190
    controls.enabled = false
    controls.target.set(-150, 2030, -100)
}

function createEntrySequence() {
    if (!isStandalone || !camera) return null

    const sequence = new THREE.Group()
    sequence.name = 'riease-complexity-entry'
    sequence.position.set(0, 2, -320)
    sequence.visible = false
    camera.add(sequence)

    const blockGeometry = new THREE.BoxGeometry(1, 1, 1)
    const blockEdges = new THREE.EdgesGeometry(blockGeometry)
    const greenMaterial = new THREE.MeshBasicMaterial({
        color: 0xaed500,
        transparent: true,
        opacity: 0.94,
        toneMapped: false
    })
    greenMaterial.userData.baseOpacity = 0.94
    const darkMaterial = new THREE.MeshStandardMaterial({
        color: 0x05090b,
        emissive: 0x314000,
        emissiveIntensity: 0.28,
        roughness: 0.32,
        metalness: 0.76,
        transparent: true,
        opacity: 0.9
    })
    darkMaterial.userData.baseOpacity = 0.9
    const edgeMaterial = new THREE.LineBasicMaterial({
        color: 0xbce527,
        transparent: true,
        opacity: 0.34,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        toneMapped: false
    })
    edgeMaterial.userData.baseOpacity = 0.34
    const entryMaterials = [greenMaterial, darkMaterial, edgeMaterial]
    const dataBlocks = []
    const compactViewport = canvas.clientWidth <= 820
    const blockCount = compactViewport ? 28 : 46

    for (let index = 0; index < blockCount; index += 1) {
        const isGreen = index % 4 === 0 || index % 11 === 0
        const block = new THREE.Mesh(blockGeometry, isGreen ? greenMaterial : darkMaterial)
        const width = 3.4 + Math.random() * 8.5
        const height = 3.4 + Math.random() * 15
        const depth = 3 + Math.random() * 6
        const angle = (index / blockCount) * Math.PI * 2 + Math.random() * 0.4
        const targetRadius = 25 + Math.random() * 10
        const targetY = (Math.random() - 0.5) * 42
        const horizontalRadius = Math.sqrt(Math.max(0, targetRadius * targetRadius - targetY * targetY * 0.42))
        const start = new THREE.Vector3(
            (Math.random() - 0.5) * (compactViewport ? 168 : 250),
            96 + Math.random() * 210,
            -48 + Math.random() * 86
        )
        const staging = new THREE.Vector3(
            Math.cos(angle) * (46 + Math.random() * 42),
            26 + Math.random() * 78,
            Math.sin(angle) * (22 + Math.random() * 28)
        )
        const target = new THREE.Vector3(
            Math.cos(angle) * horizontalRadius,
            targetY,
            Math.sin(angle) * horizontalRadius * 0.72
        )

        block.userData = {
            start,
            staging,
            target,
            baseScale: new THREE.Vector3(width, height, depth),
            delay: Math.random() * 0.22,
            phase: Math.random() * Math.PI * 2,
            spin: 0.8 + Math.random() * 1.8
        }
        block.position.copy(start)
        block.scale.setScalar(0.001)
        block.rotation.set(Math.random() * 1.2, Math.random() * 1.2, Math.random() * 0.8)

        if (!isGreen && index % 2 === 0) {
            block.add(new THREE.LineSegments(blockEdges, edgeMaterial))
        }
        sequence.add(block)
        dataBlocks.push(block)
    }

    const trailPositions = new Float32Array((compactViewport ? 24 : 42) * 6)
    for (let index = 0; index < trailPositions.length / 6; index += 1) {
        const offset = index * 6
        const x = (Math.random() - 0.5) * (compactViewport ? 190 : 290)
        const y = 55 + Math.random() * 250
        const z = -55 + Math.random() * 80
        trailPositions.set([x, y, z, x, y - 20 - Math.random() * 60, z], offset)
    }
    const trailGeometry = new THREE.BufferGeometry()
    trailGeometry.setAttribute('position', new THREE.BufferAttribute(trailPositions, 3))
    const trailMaterial = new THREE.LineBasicMaterial({
        color: 0xaed500,
        transparent: true,
        opacity: 0.16,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        toneMapped: false
    })
    trailMaterial.userData.baseOpacity = 0.16
    entryMaterials.push(trailMaterial)
    const trails = new THREE.LineSegments(trailGeometry, trailMaterial)
    sequence.add(trails)

    const core = new THREE.Group()
    core.position.y = -2
    sequence.add(core)

    const coreMaterial = new THREE.MeshBasicMaterial({
        color: 0xaed500,
        transparent: true,
        opacity: 0.72,
        blending: THREE.NormalBlending,
        depthWrite: false,
        toneMapped: false
    })
    coreMaterial.userData.baseOpacity = 0.72
    const shellMaterial = new THREE.MeshStandardMaterial({
        color: 0x07100d,
        emissive: 0x789300,
        emissiveIntensity: 0.42,
        roughness: 0.24,
        metalness: 0.74,
        transparent: true,
        opacity: 0.74,
        wireframe: true
    })
    shellMaterial.userData.baseOpacity = 0.74
    const ringMaterial = new THREE.MeshBasicMaterial({
        color: 0xc5ed31,
        transparent: true,
        opacity: 0.5,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
        toneMapped: false
    })
    ringMaterial.userData.baseOpacity = 0.5
    entryMaterials.push(coreMaterial, shellMaterial, ringMaterial)

    const innerCore = new THREE.Mesh(new THREE.IcosahedronGeometry(20, 2), coreMaterial)
    const outerShell = new THREE.Mesh(new THREE.IcosahedronGeometry(35, 2), shellMaterial)
    core.add(innerCore, outerShell)

    const orbitRings = [0, 1, 2].map((index) => {
        const ring = new THREE.Mesh(
            new THREE.TorusGeometry(48 + index * 12, index === 1 ? 0.8 : 0.45, 6, 72),
            ringMaterial
        )
        ring.rotation.set(Math.PI / 2 + index * 0.36, index * 0.52, index * 0.7)
        core.add(ring)
        return ring
    })

    const shockwaveMaterial = ringMaterial.clone()
    shockwaveMaterial.opacity = 0
    shockwaveMaterial.userData.baseOpacity = 0.72
    entryMaterials.push(shockwaveMaterial)
    const shockwave = new THREE.Mesh(new THREE.RingGeometry(38, 39.2, 96), shockwaveMaterial)
    shockwave.position.z = 8
    core.add(shockwave)

    const coreLight = new THREE.PointLight(0xbce526, 0, 230, 2)
    coreLight.position.z = 30
    core.add(coreLight)

    let disposed = false
    const clamp01 = (value) => Math.min(Math.max(value, 0), 1)
    const easeOut = (value) => 1 - Math.pow(1 - value, 3)
    const easeInOut = (value) => value < 0.5
        ? 4 * value * value * value
        : 1 - Math.pow(-2 * value + 2, 3) / 2

    function dispose() {
        if (disposed) return
        disposed = true
        sequence.visible = false
        camera.remove(sequence)
        blockGeometry.dispose()
        blockEdges.dispose()
        trailGeometry.dispose()
        innerCore.geometry.dispose()
        outerShell.geometry.dispose()
        orbitRings.forEach((ring) => ring.geometry.dispose())
        shockwave.geometry.dispose()
        entryMaterials.forEach((material) => material.dispose())
    }

    return {
        update(progress, timestamp) {
            if (disposed) return
            sequence.visible = true
            const time = timestamp * 0.001
            const globalFade = 1 - easeOut(clamp01((progress - 0.86) / 0.14))
            const collection = easeInOut(clamp01((progress - 0.48) / 0.32))
            const coreReveal = easeOut(clamp01((progress - 0.28) / 0.46))

            sequence.position.z = -326 + progress * 18
            sequence.rotation.z = Math.sin(time * 0.45) * 0.025
            trails.position.y = -progress * 155
            trailMaterial.opacity = trailMaterial.userData.baseOpacity * (1 - collection) * globalFade

            dataBlocks.forEach((block) => {
                const data = block.userData
                const fall = easeOut(clamp01((progress - data.delay) / Math.max(0.42 - data.delay, 0.12)))
                const absorb = easeInOut(clamp01((progress - 0.48 - data.delay * 0.18) / 0.29))
                const reveal = easeOut(clamp01((progress - data.delay * 0.6) / 0.09))
                block.position.lerpVectors(data.start, data.staging, fall)
                block.position.x += Math.sin(time * data.spin + data.phase) * 8 * (1 - absorb)
                block.position.z += Math.cos(time * 1.2 + data.phase) * 6 * (1 - absorb)
                block.position.lerp(data.target, absorb)
                block.rotation.x += 0.018 * data.spin
                block.rotation.y += 0.024 * data.spin
                block.rotation.z += 0.011 * data.spin
                const compression = Math.max(0.06, 1 - absorb * 0.9)
                block.scale.copy(data.baseScale).multiplyScalar(reveal * compression * globalFade)
            })

            core.visible = progress > 0.16
            core.scale.setScalar((0.35 + coreReveal * 0.65) * (1 + Math.sin(time * 4.2) * 0.018))
            core.rotation.y = time * 0.46
            core.rotation.x = Math.sin(time * 0.5) * 0.14
            innerCore.scale.setScalar(0.36 + collection * 0.84)
            innerCore.rotation.x = -time * 0.72
            innerCore.rotation.y = time * 0.88
            outerShell.rotation.x = time * 0.34
            outerShell.rotation.y = -time * 0.58
            orbitRings.forEach((ring, index) => {
                ring.rotation.z += 0.004 + index * 0.002
                ring.scale.setScalar(1.18 - collection * (0.16 + index * 0.035))
            })

            const shock = easeOut(clamp01((progress - 0.72) / 0.2))
            shockwave.scale.setScalar(0.72 + shock * 3.4)
            shockwaveMaterial.opacity = Math.sin(shock * Math.PI) * 0.62 * globalFade
            coreLight.intensity = (0.12 + collection * 0.78 + shock * 0.25) * globalFade

            greenMaterial.opacity = greenMaterial.userData.baseOpacity * globalFade
            darkMaterial.opacity = darkMaterial.userData.baseOpacity * globalFade
            edgeMaterial.opacity = edgeMaterial.userData.baseOpacity * globalFade
            coreMaterial.opacity = coreMaterial.userData.baseOpacity * coreReveal * globalFade
            shellMaterial.opacity = shellMaterial.userData.baseOpacity * coreReveal * globalFade
            ringMaterial.opacity = ringMaterial.userData.baseOpacity * coreReveal * globalFade

            if (progress >= 1) dispose()
        },
        dispose
    }
}

function setScreenSlide(index) {
    if (!screenMesh || screenMesh.userData.hasVideo || screenMesh.userData.slide === index) return
    const previousTexture = screenMesh.material.map
    screenMesh.userData.slide = index
    screenMesh.material.map = makeShowcaseTexture(index)
    screenMesh.material.needsUpdate = true
    previousTexture?.dispose()
}

function updateChapterTheme(index) {
    const theme = chapterThemes[index] || chapterThemes[0]
    exhibitionRoot.style.setProperty('--exhibition-story-accent', theme.css)
    exhibitionRoot.style.setProperty('--exhibition-story-accent-soft', theme.soft)
}

function updateStoryPanel() {
    updateChapterTheme(currentChapter)
    if (!isStandalone) return
    const chapter = chapters[currentChapter]

    if (ui.storyIndex) ui.storyIndex.textContent = String(currentChapter).padStart(2, '0')
    if (ui.storyKicker) ui.storyKicker.textContent = chapter.kicker
    if (ui.storyTitle) ui.storyTitle.textContent = chapter.title
    if (ui.storyLead) ui.storyLead.textContent = chapter.lead
    if (ui.storyBody) ui.storyBody.innerHTML = chapter.body
    if (ui.robotSpeech) ui.robotSpeech.textContent = chapter.speech
    if (ui.chapterProgress) ui.chapterProgress.textContent = `${currentChapter + 1} / ${chapters.length}`
    if (ui.previousChapter) ui.previousChapter.disabled = currentChapter === 0
    if (ui.nextChapter) ui.nextChapter.disabled = currentChapter === chapters.length - 1
    if (ui.tourProgress && !guidedTourActive) {
        ui.tourProgress.style.transition = ''
        ui.tourProgress.style.width = `${((currentChapter + 1) / chapters.length) * 100}%`
    }

    setStoryPanelOpen(true)
    ui.chapterButtons.forEach((button) => {
        const isCurrent = Number(button.dataset.chapter) === currentChapter
        button.classList.toggle('is-active', isCurrent)
        if (isCurrent) button.setAttribute('aria-current', 'step')
        else button.removeAttribute('aria-current')
    })

    setScreenSlide(currentChapter)
}

function moveCameraToChapter(index, instant = false) {
    if (!camera || !controls) return
    const view = chapterViews[index]

    if (instant || prefersReducedMotion) {
        camera.position.copy(view.position)
        controls.target.copy(view.target)
        controls.update()
        return
    }

    cameraTransition = {
        fromPosition: camera.position.clone(),
        fromTarget: controls.target.clone(),
        toPosition: view.position.clone(),
        toTarget: view.target.clone(),
        startedAt: performance.now(),
        duration: 1450
    }
    controls.enabled = false
}

function updateCameraTransition(timestamp) {
    if (!cameraTransition) return
    const progress = Math.min((timestamp - cameraTransition.startedAt) / cameraTransition.duration, 1)
    const eased = progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2

    camera.position.lerpVectors(cameraTransition.fromPosition, cameraTransition.toPosition, eased)
    controls.target.lerpVectors(cameraTransition.fromTarget, cameraTransition.toTarget, eased)

    if (progress >= 1) {
        cameraTransition = null
        controls.enabled = !introActive
    }
}

const GUIDED_CHAPTER_MS = 6200

function stopGuidedTour(announce = true) {
    guidedTourActive = false
    guidedTourPaused = false
    window.clearTimeout(guidedTourTimer)
    if (ui.tourProgress) {
        ui.tourProgress.style.transition = ''
        ui.tourProgress.style.width = `${((currentChapter + 1) / chapters.length) * 100}%`
    }
    if (ui.guidedTour) ui.guidedTour.textContent = '帶我導覽'
    exhibitionRoot.classList.remove('is-guided-tour')
    if (announce) showToast('已切換為自由探索')
}

/* 導覽進度條在本章倒數期間線性前進到下一章的位置，暫停時凍結 */
function animateTourBar(remaining) {
    if (!ui.tourProgress) return
    const elapsedRatio = (GUIDED_CHAPTER_MS - remaining) / GUIDED_CHAPTER_MS
    const from = (currentChapter + elapsedRatio) / chapters.length
    const to = (currentChapter + 1) / chapters.length
    ui.tourProgress.style.transition = 'none'
    ui.tourProgress.style.width = `${from * 100}%`
    void ui.tourProgress.offsetWidth
    ui.tourProgress.style.transition = `width ${remaining}ms linear`
    ui.tourProgress.style.width = `${to * 100}%`
}

function advanceGuidedChapter() {
    if (!guidedTourActive) return
    if (currentChapter >= chapters.length - 1) {
        stopGuidedTour(false)
        if (ui.robotSpeech) ui.robotSpeech.textContent = '完整導覽結束。你可以回到任何章節細看，或直接和睿鍶聊聊你的下一步。'
        showToast('RURU 導覽完成')
        return
    }
    selectChapter(currentChapter + 1, { fromTour: true })
    scheduleGuidedChapter()
}

function scheduleGuidedChapter() {
    window.clearTimeout(guidedTourTimer)
    guidedTourPaused = false
    guidedTourRemaining = GUIDED_CHAPTER_MS
    guidedTourStartedAt = performance.now()
    guidedTourTimer = window.setTimeout(advanceGuidedChapter, GUIDED_CHAPTER_MS)
    animateTourBar(GUIDED_CHAPTER_MS)
}

function pauseGuidedTour() {
    if (!guidedTourActive || guidedTourPaused) return
    guidedTourPaused = true
    window.clearTimeout(guidedTourTimer)
    guidedTourRemaining = Math.max(0, guidedTourRemaining - (performance.now() - guidedTourStartedAt))
    if (ui.tourProgress) {
        const frozenWidth = window.getComputedStyle(ui.tourProgress).width
        ui.tourProgress.style.transition = 'none'
        ui.tourProgress.style.width = frozenWidth
    }
}

function resumeGuidedTour() {
    if (!guidedTourActive || !guidedTourPaused) return
    guidedTourPaused = false
    guidedTourStartedAt = performance.now()
    guidedTourTimer = window.setTimeout(advanceGuidedChapter, guidedTourRemaining)
    animateTourBar(guidedTourRemaining)
}

function startGuidedTour() {
    if (guidedTourActive) {
        stopGuidedTour()
        return
    }

    guidedTourActive = true
    if (ui.guidedTour) ui.guidedTour.textContent = '停止導覽'
    exhibitionRoot.classList.add('is-guided-tour')
    selectChapter(currentChapter >= chapters.length - 1 ? 0 : currentChapter, { fromTour: true })
    if (ui.robotSpeech) ui.robotSpeech.textContent = '跟著我走吧。我會移動鏡頭，帶你看完七個最重要的故事。'
    triggerRobotReaction('wave')
    scheduleGuidedChapter()
}

function selectChapter(index, { fromTour = false, moveCamera = true } = {}) {
    const nextIndex = Math.max(0, Math.min(index, chapters.length - 1))
    if (!fromTour && guidedTourActive) stopGuidedTour(false)

    currentChapter = nextIndex
    factCursor = 0
    updateStoryPanel()
    setActiveArchitectureZone(currentChapter)
    if (moveCamera && experienceStarted && !introActive) moveCameraToChapter(currentChapter)
    if (experienceStarted && !introActive) setRobotChapterPose(currentChapter)
    triggerRobotReaction(currentChapter === 6 ? 'spin' : 'wave')
}

function revealRobotFact() {
    const chapter = chapters[currentChapter]
    if (!chapter || !ui.robotSpeech) return
    ui.robotSpeech.textContent = chapter.facts[factCursor % chapter.facts.length]
    factCursor += 1
    triggerRobotReaction('wave')
}

function resetView() {
    if (!camera || !controls || introActive) return
    clearMovementDirections()
    if (isStandalone) {
        selectChapter(0)
        showToast('已回到故事入口')
    } else {
        camera.position.copy(chapterViews[0].position)
        controls.target.copy(chapterViews[0].target)
        controls.update()
    }
}

function beginExperience() {
    if (experienceStarted) return
    experienceStarted = true
    exhibitionRoot.classList.add('is-entering')
    ui.loader?.classList.add('is-hidden')
    setStatus('正在收束複雜資訊')
    updateStoryPanel()
    setActiveArchitectureZone(currentChapter)
    setRobotChapterPose(currentChapter, true)
    const viewport = exhibitionRoot.getBoundingClientRect()
    if (isMobilePortraitViewport(viewport.width, viewport.height)) setStorySheetCollapsed(true)
    if (ui.robotSpeech) ui.robotSpeech.textContent = '歡迎進入睿鍶互動品牌展間。先看看入口，再跟我往下一章走。'
}

function setupStoryExperience() {
    if (!isStandalone) return
    updateStoryPanel()

    ui.chapterButtons.forEach((button) => {
        button.addEventListener('click', () => selectChapter(Number(button.dataset.chapter)))
    })
    ui.hotspots.forEach((button) => {
        button.addEventListener('click', () => selectChapter(Number(button.dataset.chapter)))
    })
    ui.previousChapter?.addEventListener('click', () => selectChapter(currentChapter - 1))
    ui.nextChapter?.addEventListener('click', () => selectChapter(currentChapter + 1))
    ui.storyClose?.addEventListener('click', () => setStoryPanelOpen(false))
    ui.guidedTour?.addEventListener('click', startGuidedTour)
    ui.robotFact?.addEventListener('click', revealRobotFact)
}

function setupInteractions() {
    const raycaster = new THREE.Raycaster()
    const pointer = new THREE.Vector2()
    const faceCanvas = document.createElement('canvas')
    faceCanvas.width = 1024
    faceCanvas.height = 512
    const faceContext = faceCanvas.getContext('2d')
    const dynamicFaceTexture = new THREE.CanvasTexture(faceCanvas)
    dynamicFaceTexture.flipY = true
    dynamicFaceTexture.encoding = THREE.sRGBEncoding
    dynamicFaceTexture.minFilter = THREE.LinearFilter
    dynamicFaceTexture.magFilter = THREE.LinearFilter
    dynamicFaceTexture.anisotropy = renderer.capabilities.getMaxAnisotropy()
    dynamicFaceTexture.wrapS = THREE.ClampToEdgeWrapping
    dynamicFaceTexture.wrapT = THREE.ClampToEdgeWrapping
    const facePanels = [{ x: 0, y: 0, width: faceCanvas.width, height: faceCanvas.height }]
    let faceExpression = 'welcome'
    let faceExpressionUntil = 0
    let faceSpeechUntil = 0
    let faceLastFrame = -Infinity
    const rightArm = robot.getObjectByName('Bone011')
    const headBone = robot.getObjectByName('Bone005')
    const leftLeg = robot.getObjectByName('Bone021')
    const rightLeg = robot.getObjectByName('Bone016')
    const animatedBones = [leftArm, rightArm, headBone, leftLeg, rightLeg].filter(Boolean)
    const boneBaseRotations = new Map(animatedBones.map((bone) => [bone, bone.rotation.clone()]))
    const robotGroundPosition = robot.position.clone()
    let robotGroundRotation = robot.rotation.y
    let robotMove
    let chapterAction = 'welcome'
    let chapterActionStartedAt = performance.now()
    let waveStartedAt = 0
    let waveUntil = 0
    let spinStartedAt = 0

    const robotFillLight = new THREE.PointLight(0xc9eff7, 0.48, 185, 2)
    robotFillLight.name = 'ruru-soft-fill'
    robotFillLight.position.copy(robot.position).add(new THREE.Vector3(0, 58, 34))
    scene.add(robotFillLight)

    const robotEffects = new THREE.Group()
    robotEffects.name = 'ruru-action-effects'
    robotEffects.visible = false
    const auraMaterial = new THREE.MeshBasicMaterial({
        color: 0xaed500,
        transparent: true,
        opacity: 0.46,
        depthWrite: false
    })
    const baseAura = new THREE.Mesh(new THREE.TorusGeometry(42, 1.35, 6, 52), auraMaterial)
    baseAura.rotation.x = Math.PI / 2
    robotEffects.add(baseAura)

    const pointChevrons = Array.from({ length: 3 }, (_, index) => {
        const chevron = new THREE.Mesh(
            new THREE.ConeGeometry(5.5, 13, 3),
            auraMaterial.clone()
        )
        chevron.rotation.z = -Math.PI / 2
        chevron.position.set(-58 - index * 14, 38, 0)
        robotEffects.add(chevron)
        return chevron
    })

    const showcaseNodes = Array.from({ length: 6 }, (_, index) => {
        const node = new THREE.Mesh(
            new THREE.OctahedronGeometry(3.8, 0),
            auraMaterial.clone()
        )
        node.userData.phase = (index / 6) * Math.PI * 2
        robotEffects.add(node)
        return node
    })

    const scanRing = new THREE.Mesh(
        new THREE.TorusGeometry(53, 1.5, 6, 64),
        auraMaterial.clone()
    )
    scanRing.position.y = 42
    robotEffects.add(scanRing)

    const walkTrails = Array.from({ length: 5 }, (_, index) => {
        const trail = new THREE.Mesh(
            new THREE.BoxGeometry(20 - index * 2.5, 0.9, 3),
            auraMaterial.clone()
        )
        trail.position.set(0, 1 + index * 0.18, 32 + index * 13)
        trail.material.opacity = 0.42 - index * 0.055
        robotEffects.add(trail)
        return trail
    })

    const celebrationBursts = Array.from({ length: 10 }, (_, index) => {
        const burst = new THREE.Mesh(
            new THREE.TetrahedronGeometry(3.4, 0),
            auraMaterial.clone()
        )
        burst.userData.phase = (index / 10) * Math.PI * 2
        robotEffects.add(burst)
        return burst
    })
    scene.add(robotEffects)

    function drawRobotFace(timestamp = performance.now(), expression = faceExpression) {
        const blinkCycle = timestamp % 4300
        const blink = blinkCycle < 150 ? Math.sin((blinkCycle / 150) * Math.PI) : 0
        const speaking = timestamp < faceSpeechUntil
        const talk = speaking ? (Math.sin(timestamp * 0.021) + 1) * 0.5 : 0
        const glowPulse = 0.86 + Math.sin(timestamp * 0.0034) * 0.08

        faceContext.clearRect(0, 0, faceCanvas.width, faceCanvas.height)
        facePanels.forEach((panel) => {
        const x = 0
        const y = 0
        const width = 952
        const height = 480
        const centerX = width * 0.5
        const eyeY = height * 0.48
        const leftEyeX = width * 0.31
        const rightEyeX = width * 0.69
        const mouthY = height * 0.7
        faceContext.save()
        faceContext.translate(panel.x, panel.y)
        faceContext.scale(panel.width / width, panel.height / height)
        faceContext.beginPath()
        faceContext.roundRect(x, y, width, height, 88)
        faceContext.clip()

        const screenGradient = faceContext.createRadialGradient(centerX, eyeY, 20, centerX, eyeY, width * 0.62)
        screenGradient.addColorStop(0, '#101b44')
        screenGradient.addColorStop(0.56, '#070d25')
        screenGradient.addColorStop(1, '#02040e')
        faceContext.fillStyle = screenGradient
        faceContext.fillRect(x, y, width, height)

        faceContext.globalAlpha = 0.08
        faceContext.strokeStyle = '#76f6ff'
        faceContext.lineWidth = 2
        for (let row = y + 16; row < y + height; row += 22) {
            faceContext.beginPath()
            faceContext.moveTo(x, row)
            faceContext.lineTo(x + width, row)
            faceContext.stroke()
        }
        faceContext.globalAlpha = 1

        const faceGradient = faceContext.createLinearGradient(x + width * 0.18, eyeY, x + width * 0.82, eyeY)
        faceGradient.addColorStop(0, '#75ffd2')
        faceGradient.addColorStop(0.48, '#55d9ff')
        faceGradient.addColorStop(1, '#8c9dff')
        faceContext.strokeStyle = faceGradient
        faceContext.fillStyle = faceGradient
        faceContext.lineCap = 'round'
        faceContext.lineJoin = 'round'
        faceContext.shadowColor = '#52ddff'
        faceContext.shadowBlur = 34 * glowPulse

        function drawRoundEye(eyeX, look = 0, scale = 1) {
            const eyeHeight = Math.max(10, 92 * scale * (1 - blink * 0.9))
            faceContext.lineWidth = 28
            faceContext.beginPath()
            faceContext.ellipse(eyeX, eyeY, 58 * scale, eyeHeight / 2, 0, 0, Math.PI * 2)
            faceContext.stroke()
            if (blink < 0.72) {
                faceContext.shadowBlur = 16
                faceContext.beginPath()
                faceContext.arc(eyeX + look, eyeY, 18 * scale, 0, Math.PI * 2)
                faceContext.fill()
                faceContext.shadowBlur = 34 * glowPulse
            }
        }

        function drawHappyEye(eyeX, direction = 1) {
            faceContext.lineWidth = 31
            faceContext.beginPath()
            faceContext.moveTo(eyeX - 56, eyeY + 20 * direction)
            faceContext.quadraticCurveTo(eyeX, eyeY - 54 * direction, eyeX + 56, eyeY + 20 * direction)
            faceContext.stroke()
        }

        function drawChevronEye(eyeX, direction = 1) {
            faceContext.lineWidth = 31
            faceContext.beginPath()
            faceContext.moveTo(eyeX - 38 * direction, eyeY - 48)
            faceContext.lineTo(eyeX + 38 * direction, eyeY)
            faceContext.lineTo(eyeX - 38 * direction, eyeY + 48)
            faceContext.stroke()
        }

        if (expression === 'point') {
            drawRoundEye(leftEyeX, 18, 1.02)
            drawChevronEye(rightEyeX, -1)
        } else if (expression === 'showcase') {
            ;[leftEyeX, rightEyeX].forEach((eyeX, index) => {
                faceContext.lineWidth = 26
                faceContext.strokeRect(eyeX - 50, eyeY - 46 + index * 4, 100, 92)
                faceContext.fillRect(eyeX - 13 + Math.sin(timestamp * 0.004 + index) * 13, eyeY - 13, 26, 26)
            })
        } else if (expression === 'ai') {
            ;[leftEyeX, rightEyeX].forEach((eyeX, eyeIndex) => {
                faceContext.lineWidth = 24
                faceContext.beginPath()
                faceContext.arc(eyeX, eyeY, 54, 0, Math.PI * 2)
                faceContext.stroke()
                for (let nodeIndex = 0; nodeIndex < 3; nodeIndex += 1) {
                    const angle = timestamp * 0.0024 * (eyeIndex ? -1 : 1) + nodeIndex * Math.PI * 2 / 3
                    faceContext.beginPath()
                    faceContext.arc(eyeX + Math.cos(angle) * 34, eyeY + Math.sin(angle) * 34, 8, 0, Math.PI * 2)
                    faceContext.fill()
                }
            })
        } else if (expression === 'walk') {
            drawRoundEye(leftEyeX, 24, 0.92)
            drawRoundEye(rightEyeX, 24, 0.92)
        } else if (expression === 'scan') {
            faceContext.lineWidth = 27
            ;[leftEyeX, rightEyeX].forEach((eyeX) => {
                faceContext.beginPath()
                faceContext.moveTo(eyeX - 62, eyeY)
                faceContext.lineTo(eyeX + 62, eyeY)
                faceContext.stroke()
                faceContext.fillRect(eyeX - 10 + Math.sin(timestamp * 0.006) * 36, eyeY - 24, 20, 48)
            })
            const scanX = x + ((timestamp * 0.22) % width)
            const scanGradient = faceContext.createLinearGradient(scanX - 80, 0, scanX + 12, 0)
            scanGradient.addColorStop(0, 'rgba(92, 222, 255, 0)')
            scanGradient.addColorStop(1, 'rgba(92, 222, 255, 0.52)')
            faceContext.fillStyle = scanGradient
            faceContext.fillRect(scanX - 80, y, 92, height)
            faceContext.fillStyle = faceGradient
        } else if (expression === 'celebrate') {
            drawHappyEye(leftEyeX)
            drawHappyEye(rightEyeX)
            faceContext.fillStyle = '#ef86ff'
            faceContext.shadowColor = '#ef86ff'
            for (let index = 0; index < 8; index += 1) {
                const angle = (index / 8) * Math.PI * 2 + timestamp * 0.0008
                const radius = 255 + Math.sin(timestamp * 0.004 + index) * 22
                faceContext.save()
                faceContext.translate(centerX + Math.cos(angle) * radius, eyeY + 32 + Math.sin(angle) * radius * 0.62)
                faceContext.rotate(angle)
                faceContext.fillRect(-9, -22, 18, 44)
                faceContext.restore()
            }
            faceContext.fillStyle = faceGradient
            faceContext.shadowColor = '#52ddff'
        } else {
            drawRoundEye(leftEyeX, -8, 1)
            drawRoundEye(rightEyeX, 8, 1)
        }

        faceContext.strokeStyle = faceGradient
        faceContext.lineWidth = 29
        faceContext.shadowBlur = 30 * glowPulse
        faceContext.beginPath()
        if (speaking) {
            const mouthHeight = 22 + talk * 45
            faceContext.ellipse(centerX, mouthY, 58 + talk * 12, mouthHeight, 0, 0, Math.PI * 2)
        } else if (expression === 'celebrate') {
            faceContext.arc(centerX, mouthY - 30, 82, 0.12 * Math.PI, 0.88 * Math.PI)
        } else if (expression === 'scan') {
            faceContext.moveTo(centerX - 48, mouthY)
            faceContext.lineTo(centerX + 48, mouthY)
        } else {
            faceContext.arc(centerX, mouthY - 42, 68, 0.16 * Math.PI, 0.84 * Math.PI)
        }
        faceContext.stroke()

        faceContext.fillStyle = '#ef86ff'
        faceContext.shadowColor = '#ef86ff'
        faceContext.shadowBlur = 24
        faceContext.beginPath()
        faceContext.arc(x + width * 0.15, mouthY - 2, 18, 0, Math.PI * 2)
        faceContext.arc(x + width * 0.85, mouthY - 2, 18, 0, Math.PI * 2)
        faceContext.fill()

        const glint = faceContext.createLinearGradient(x, y, x + width, y + height)
        glint.addColorStop(0, 'rgba(255,255,255,0.12)')
        glint.addColorStop(0.22, 'rgba(255,255,255,0)')
        glint.addColorStop(1, 'rgba(255,255,255,0.035)')
        faceContext.shadowBlur = 0
        faceContext.fillStyle = glint
        faceContext.fillRect(x, y, width, height)

        // A restrained inner rim keeps the animated surface feeling like glass
        // recessed behind the robot shell instead of a card placed on top.
        const innerRim = faceContext.createLinearGradient(x, y, x + width, y + height)
        innerRim.addColorStop(0, 'rgba(202, 249, 255, 0.22)')
        innerRim.addColorStop(0.45, 'rgba(95, 212, 255, 0.08)')
        innerRim.addColorStop(1, 'rgba(38, 74, 126, 0.28)')
        faceContext.strokeStyle = innerRim
        faceContext.lineWidth = 10
        faceContext.beginPath()
        faceContext.roundRect(x + 8, y + 8, width - 16, height - 16, 78)
        faceContext.stroke()
        faceContext.restore()
        })

        dynamicFaceTexture.needsUpdate = true
    }

    drawRobotFace()
    const faceShaderState = {
        shader: null,
        brightness: 0.94
    }
    let originalInsetFaceMesh = null
    let robotSurfaceMaterial = null
    robot.traverse((object) => {
        if (!object.isMesh || !object.material) return
        const materials = Array.isArray(object.material) ? object.material : [object.material]
        if (materials.some((material) => material.name?.includes('CuteRobotFaceTexture'))) {
            originalInsetFaceMesh = object
        }
        const surfaceMaterial = materials.find((material) => material.name === 'robot' && material.map)
        if (surfaceMaterial) {
            robotSurfaceMaterial = surfaceMaterial
        }
    })

    // This recessed export surface sits behind the textured face shell. Keep it
    // hidden so it can never become a blue sliver at oblique camera angles.
    if (originalInsetFaceMesh) originalInsetFaceMesh.visible = false

    if (robotSurfaceMaterial) {
        const previousCompile = robotSurfaceMaterial.onBeforeCompile
        robotSurfaceMaterial.onBeforeCompile = (shader, rendererInstance) => {
            previousCompile?.(shader, rendererInstance)
            shader.uniforms.ruruFaceMap = { value: dynamicFaceTexture }
            shader.uniforms.ruruFaceBrightness = { value: faceShaderState.brightness }
            shader.fragmentShader = shader.fragmentShader.replace(
                '#define STANDARD',
                `#define STANDARD
uniform sampler2D ruruFaceMap;
uniform float ruruFaceBrightness;
float ruruFaceMask;
vec4 ruruFaceTexel;`
            )
            shader.fragmentShader = shader.fragmentShader.replace(
                '#include <map_fragment>',
                `#include <map_fragment>
#ifdef USE_MAP
    vec2 ruruFaceUv = vec2(
        (vUv.x - 0.554287) / 0.110960,
        (vUv.y - 0.024434) / 0.087658
    );
    float ruruFaceMaskX = step(0.552, vUv.x) * step(vUv.x, 0.668);
    float ruruFaceMaskY = step(0.022, vUv.y) * step(vUv.y, 0.114);
    ruruFaceMask = ruruFaceMaskX * ruruFaceMaskY;
    vec2 ruruFaceSampleUv = vec2(
        1.0 - clamp(ruruFaceUv.x, 0.0, 1.0),
        clamp(ruruFaceUv.y, 0.0, 1.0)
    );
    ruruFaceTexel = mapTexelToLinear(texture2D(ruruFaceMap, ruruFaceSampleUv));
    diffuseColor = mix(diffuseColor, ruruFaceTexel, ruruFaceMask);
#else
    ruruFaceMask = 0.0;
    ruruFaceTexel = vec4(0.0);
#endif`
            )
            shader.fragmentShader = shader.fragmentShader.replace(
                '#include <emissivemap_fragment>',
                `#include <emissivemap_fragment>
totalEmissiveRadiance = mix(
    totalEmissiveRadiance,
    ruruFaceTexel.rgb * ruruFaceBrightness,
    ruruFaceMask
);`
            )
            faceShaderState.shader = shader
        }
        robotSurfaceMaterial.customProgramCacheKey = () => 'ruru-native-face-v2'
        robotSurfaceMaterial.needsUpdate = true
    } else {
        console.warn('RURU textured face surface was not found; dynamic face disabled.')
    }

    setRobotFace = async (state) => {
        const now = performance.now()
        if (state === undefined) {
            faceExpression = 'celebrate'
            faceExpressionUntil = now + 1500
        } else {
            faceExpression = typeof state === 'number'
                ? (robotChapterPoses[state] || robotChapterPoses[0]).action
                : state
            faceExpressionUntil = 0
        }
        faceSpeechUntil = now + 2600
        drawRobotFace(now)
    }

    triggerRobotReaction = (type = 'wave') => {
        const now = performance.now()
        waveStartedAt = now
        waveUntil = now + 1700
        faceSpeechUntil = Math.max(faceSpeechUntil, now + 1900)
        if (type === 'spin') spinStartedAt = now
    }

    setRobotChapterPose = (chapter, instant = false) => {
        const pose = robotChapterPoses[chapter] || robotChapterPoses[0]
        const view = chapterViews[chapter]
        const viewport = exhibitionRoot.getBoundingClientRect()
        const mobilePortrait = isMobilePortraitViewport(viewport.width, viewport.height)
        const forward = view.target.clone().sub(view.position).normalize()
        const screenRight = forward.clone().cross(new THREE.Vector3(0, 1, 0)).normalize()
        const guideDistance = mobilePortrait ? 210 : 175
        const horizontalHalfSpan = guideDistance
            * Math.tan(THREE.MathUtils.degToRad(camera.fov / 2))
            * camera.aspect
        const screenOffset = mobilePortrait ? -horizontalHalfSpan * 0.3 : -55
        const destination = view.position.clone()
            .add(forward.multiplyScalar(guideDistance))
            .add(screenRight.multiplyScalar(screenOffset))
        destination.y = mobilePortrait ? 88 : 70
        const toCamera = chapterViews[chapter].position.clone().sub(destination)
        const destinationRotation = Math.atan2(toCamera.x, toCamera.z)
        const startedAt = performance.now()
        chapterAction = pose.action
        chapterActionStartedAt = startedAt
        if (ui.robotMode) ui.robotMode.textContent = robotActionLabels[pose.action]
        robotEffects.visible = true
        robotEffects.position.copy(robot.position)

        if (instant || prefersReducedMotion) {
            robotGroundPosition.copy(destination)
            robotGroundRotation = destinationRotation
            robot.position.copy(destination)
            robot.rotation.y = destinationRotation
            robotMove = null
        } else {
            robotMove = {
                fromPosition: robot.position.clone(),
                toPosition: destination,
                fromRotation: robot.rotation.y,
                toRotation: destinationRotation,
                startedAt,
                duration: 1450
            }
        }

        setRobotFace(chapter).catch(() => {})
    }

    function moveBone(bone, offsets, amount = 0.14) {
        if (!bone) return
        const base = boneBaseRotations.get(bone)
        bone.rotation.x += (base.x + (offsets.x || 0) - bone.rotation.x) * amount
        bone.rotation.y += (base.y + (offsets.y || 0) - bone.rotation.y) * amount
        bone.rotation.z += (base.z + (offsets.z || 0) - bone.rotation.z) * amount
    }

    function updatePointer(event) {
        const bounds = canvas.getBoundingClientRect()
        pointer.x = ((event.clientX - bounds.left) / bounds.width) * 2 - 1
        pointer.y = -((event.clientY - bounds.top) / bounds.height) * 2 + 1
    }

    function findInteractive() {
        raycaster.setFromCamera(pointer, camera)
        const intersects = raycaster.intersectObjects([screenMesh].filter(Boolean), true)
        return intersects.length ? 'screen' : null
    }

    function positionTooltip(event, message) {
        if (!ui.tooltip) return
        const bounds = canvas.getBoundingClientRect()
        const x = Math.min(event.clientX - bounds.left + 18, bounds.width - 220)
        const y = Math.max(event.clientY - bounds.top - 46, 76)
        ui.tooltip.textContent = message
        ui.tooltip.style.left = `${x}px`
        ui.tooltip.style.top = `${y}px`
        ui.tooltip.style.display = 'block'
    }

    canvas.addEventListener('pointermove', (event) => {
        if (introActive || cameraTransition || event.pointerType === 'touch') return
        updatePointer(event)
        const target = findInteractive()
        canvas.classList.toggle('is-interactive', Boolean(target))
        if (target === 'screen') positionTooltip(event, '點擊螢幕切換品牌章節')
        else if (ui.tooltip) ui.tooltip.style.display = 'none'
    }, { passive: true })

    canvas.addEventListener('pointerleave', () => {
        canvas.classList.remove('is-interactive')
        if (ui.tooltip) ui.tooltip.style.display = 'none'
    })

    canvas.addEventListener('click', async (event) => {
        if (introActive || cameraTransition) return
        updatePointer(event)
        const target = findInteractive()

        if (target === 'screen') {
            if (screenMesh.userData.hasVideo) {
                const video = document.getElementById('video')
                if (video.paused) await video.play().catch(() => {})
                else video.pause()
                showToast(video.paused ? '展示影片已暫停' : '展示影片播放中')
            } else if (isStandalone) {
                selectChapter((currentChapter + 1) % chapters.length)
                showToast(`前往第 ${String(currentChapter).padStart(2, '0')} 章`)
            } else {
                const nextSlide = (screenMesh.userData.slide + 1) % chapters.length
                setScreenSlide(nextSlide)
                showToast(`展示內容 ${nextSlide + 1} / ${chapters.length}`)
            }
        }

    })

    return (timestamp) => {
        const time = timestamp * 0.001
        const actionTime = Math.max(0, (timestamp - chapterActionStartedAt) * 0.001)
        let extraBob = 0

        if (faceExpressionUntil && timestamp >= faceExpressionUntil) {
            faceExpression = chapterAction
            faceExpressionUntil = 0
        }
        if (timestamp - faceLastFrame > 72) {
            faceLastFrame = timestamp
            drawRobotFace(timestamp, faceExpression)
            const screenPulse = timestamp < faceSpeechUntil ? 0.045 + Math.sin(time * 7.5) * 0.025 : 0
            faceShaderState.brightness = Math.min(1, 0.94 + screenPulse)
            if (faceShaderState.shader) {
                faceShaderState.shader.uniforms.ruruFaceBrightness.value = faceShaderState.brightness
            }
        }

        if (robotMove) {
            const progress = Math.min((timestamp - robotMove.startedAt) / robotMove.duration, 1)
            const eased = progress < 0.5
                ? 4 * progress * progress * progress
                : 1 - Math.pow(-2 * progress + 2, 3) / 2
            const rotationDelta = Math.atan2(
                Math.sin(robotMove.toRotation - robotMove.fromRotation),
                Math.cos(robotMove.toRotation - robotMove.fromRotation)
            )

            robotGroundPosition.lerpVectors(robotMove.fromPosition, robotMove.toPosition, eased)
            robotGroundRotation = robotMove.fromRotation + rotationDelta * eased
            robot.position.copy(robotGroundPosition)
            robot.position.y += Math.sin(progress * Math.PI) * 13

            if (progress >= 1) {
                robotGroundPosition.copy(robotMove.toPosition)
                robotGroundRotation = robotMove.toRotation
                robotMove = null
            }
        } else {
            robot.position.copy(robotGroundPosition)
        }

        const leftArmOffset = { x: 0, y: 0, z: 0 }
        const rightArmOffset = { x: 0, y: 0, z: 0 }
        const headOffset = { x: 0, y: 0, z: 0 }
        const leftLegOffset = { x: 0, y: 0, z: 0 }
        const rightLegOffset = { x: 0, y: 0, z: 0 }

        if (chapterAction === 'welcome') {
            leftArmOffset.z = -0.18 + Math.sin(actionTime * 4.8) * 0.24
            headOffset.y = Math.sin(actionTime * 1.1) * 0.08
        } else if (chapterAction === 'point') {
            leftArmOffset.z = -1.02
            leftArmOffset.x = -0.46
            rightArmOffset.z = 0.22
            headOffset.y = -0.18 + Math.sin(actionTime * 0.9) * 0.05
        } else if (chapterAction === 'showcase') {
            leftArmOffset.z = -0.92 + Math.sin(actionTime * 1.7) * 0.1
            rightArmOffset.z = 0.92 - Math.sin(actionTime * 1.7) * 0.1
            headOffset.x = Math.sin(actionTime * 1.4) * 0.07
            extraBob = (Math.sin(actionTime * 2) + 1) * 0.55
        } else if (chapterAction === 'ai') {
            leftArmOffset.z = -0.66 + Math.sin(actionTime * 1.5) * 0.08
            rightArmOffset.z = 0.66 - Math.sin(actionTime * 1.5) * 0.08
            leftArmOffset.x = -0.24
            rightArmOffset.x = -0.24
            headOffset.y = Math.sin(actionTime * 0.9) * 0.12
            extraBob = (Math.sin(actionTime * 1.8) + 1) * 0.72
        } else if (chapterAction === 'walk') {
            const stride = Math.sin(actionTime * 4.6) * 0.48
            leftArmOffset.x = stride
            rightArmOffset.x = -stride
            leftLegOffset.x = -stride * 0.72
            rightLegOffset.x = stride * 0.72
            extraBob = Math.abs(Math.sin(actionTime * 4.6)) * 1.8
        } else if (chapterAction === 'scan') {
            rightArmOffset.x = -0.82
            rightArmOffset.z = 0.46
            leftArmOffset.z = -0.32
            headOffset.y = Math.sin(actionTime * 1.65) * 0.46
            headOffset.x = -0.12
        } else if (chapterAction === 'celebrate') {
            leftArmOffset.z = -1.12 + Math.sin(actionTime * 3.2) * 0.14
            rightArmOffset.z = 1.12 - Math.sin(actionTime * 3.2) * 0.14
            leftLegOffset.z = Math.sin(actionTime * 2.4) * 0.07
            rightLegOffset.z = -Math.sin(actionTime * 2.4) * 0.07
            extraBob = (Math.sin(actionTime * 2.7) + 1) * 2.4
        }

        if (timestamp < waveUntil) {
            const progress = (timestamp - waveStartedAt) / Math.max(waveUntil - waveStartedAt, 1)
            leftArmOffset.z += Math.sin(progress * Math.PI * 5) * 0.32
        }

        /* 頭部微幅轉向鏡頭，掃描動作除外（它有自己的擺頭節奏） */
        if (camera && chapterAction !== 'scan' && !prefersReducedMotion) {
            const towardCamera = Math.atan2(
                camera.position.x - robot.position.x,
                camera.position.z - robot.position.z
            )
            const gazeDelta = Math.atan2(
                Math.sin(towardCamera - robotGroundRotation),
                Math.cos(towardCamera - robotGroundRotation)
            )
            headOffset.y += THREE.MathUtils.clamp(gazeDelta, -0.5, 0.5) * 0.34
        }

        moveBone(leftArm, leftArmOffset)
        moveBone(rightArm, rightArmOffset)
        moveBone(headBone, headOffset, 0.1)
        moveBone(leftLeg, leftLegOffset)
        moveBone(rightLeg, rightLegOffset)

        if (!robotMove) robot.position.y = robotGroundPosition.y + Math.sin(timestamp * 0.0022) * 1.15 + extraBob

        let displayRotation = robotGroundRotation
        if (spinStartedAt) {
            const progress = Math.min((timestamp - spinStartedAt) / 1150, 1)
            const eased = 1 - Math.pow(1 - progress, 3)
            displayRotation += Math.PI * 2 * eased
            if (progress >= 1) spinStartedAt = 0
        }
        robot.rotation.y = displayRotation

        robotFillLight.position.set(
            robot.position.x + Math.sin(displayRotation) * 34,
            robot.position.y + 58,
            robot.position.z + Math.cos(displayRotation) * 34
        )
        robotFillLight.intensity = Math.min(
            0.56,
            0.42 + (timestamp < faceSpeechUntil ? 0.065 : 0) + (chapterAction === 'celebrate' ? 0.045 : 0)
        )

        robotEffects.position.copy(robot.position)
        robotEffects.rotation.y = robot.rotation.y
        baseAura.scale.setScalar(1 + Math.sin(time * 2.4) * 0.08)
        baseAura.material.opacity = chapterAction === 'celebrate' ? 0.4 : 0.26

        /* 各組動作特效只在對應的章節動作亮起；RURU 移動中一律先收起 */
        const effectsActive = robotEffects.visible && !robotMove && !prefersReducedMotion

        pointChevrons.forEach((chevron, index) => {
            chevron.visible = effectsActive && chapterAction === 'point'
            chevron.position.x = -58 - index * 14 - Math.sin(time * 3.1 + index * 0.7) * 4
        })

        showcaseNodes.forEach((node) => {
            const angle = time * 1.25 + node.userData.phase
            node.visible = effectsActive && (chapterAction === 'showcase' || chapterAction === 'ai')
            node.position.set(
                Math.cos(angle) * 56,
                36 + Math.sin(angle * 2) * 9,
                Math.sin(angle) * 56
            )
            node.rotation.y = -time * 1.8
        })

        scanRing.visible = effectsActive && chapterAction === 'scan'
        scanRing.rotation.x = time * 0.55
        scanRing.rotation.y = time * 1.25

        walkTrails.forEach((trail, index) => {
            trail.visible = effectsActive && chapterAction === 'walk'
            trail.position.z = 32 + index * 13 + ((time * 24) % 13)
        })

        celebrationBursts.forEach((burst) => {
            const pulse = 52 + (Math.sin(time * 2.8 + burst.userData.phase) + 1) * 8
            burst.visible = effectsActive && chapterAction === 'celebrate'
            burst.position.set(
                Math.cos(burst.userData.phase) * pulse,
                42 + Math.sin(time * 2.2 + burst.userData.phase) * 22,
                Math.sin(burst.userData.phase) * pulse
            )
            burst.rotation.x = time * 1.4 + burst.userData.phase
            burst.rotation.y = -time * 1.1
        })
        hiddenBones?.updateMatrixWorld(true)
    }
}

function updateHotspots() {
    if (!isStandalone || !experienceStarted || introActive || !camera) return
    const bounds = canvas.getBoundingClientRect()
    const storyBounds = ui.storyPanel?.classList.contains('is-closed')
        ? null
        : ui.storyPanel?.getBoundingClientRect()
    const railBounds = ui.chapterRail?.getBoundingClientRect()
    const dialogueBounds = ui.robotDialogue?.getBoundingClientRect()

    ui.hotspots.forEach((button) => {
        const chapterIndex = Number(button.dataset.chapter)
        const anchor = hotspotAnchors.get(chapterIndex)
        if (!anchor) return
        const projected = anchor.clone().project(camera)
        const x = (projected.x * 0.5 + 0.5) * bounds.width
        const y = (-projected.y * 0.5 + 0.5) * bounds.height
        const pageX = bounds.left + x
        const pageY = bounds.top + y
        const overlapsStory = storyBounds
            && pageX > storyBounds.left - 70
            && pageX < storyBounds.right + 70
            && pageY > storyBounds.top - 30
            && pageY < storyBounds.bottom + 30
        const overlapsRail = railBounds
            && pageX > railBounds.left - 40
            && pageX < railBounds.right + 120
            && pageY > railBounds.top - 24
            && pageY < railBounds.bottom + 24
        const overlapsDialogue = dialogueBounds
            && pageX > dialogueBounds.left - 60
            && pageX < dialogueBounds.right + 60
            && pageY > dialogueBounds.top - 24
            && pageY < dialogueBounds.bottom + 24
        const outside = projected.z < -1
            || projected.z > 1
            || x < 24
            || x > bounds.width - 24
            || y < 70
            || y > bounds.height - 54

        button.classList.toggle(
            'is-hidden',
            chapterIndex === currentChapter || outside || Boolean(overlapsStory) || Boolean(overlapsRail) || Boolean(overlapsDialogue)
        )
        button.style.left = `${x}px`
        button.style.top = `${y}px`
    })
}

function setupHomePageTrigger() {
    if (isStandalone) return () => experienceStarted
    let active = false
    const handleScroll = () => {
        const { top, height } = canvas.getBoundingClientRect()
        if (top < (window.innerHeight - height) / 2) {
            active = true
            window.removeEventListener('scroll', handleScroll)
        }
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => active
}

function startExperience() {
    configureModels()
    scene.add(exhibit, robot)
    setupRendererAndCamera()
    createEnvironment()

    /* 拉高貼圖各向異性取樣，改善地板與牆面在斜視角下的清晰度 */
    const maxAnisotropy = renderer.capabilities.getMaxAnisotropy()
    ;[exhibit, robot].forEach((model) => model.traverse((object) => {
        if (!object.isMesh) return
        const materials = Array.isArray(object.material) ? object.material : [object.material]
        materials.forEach((material) => {
            if (material?.map) {
                material.map.anisotropy = maxAnisotropy
                material.map.needsUpdate = true
            }
        })
    }))
    const entrySequence = createEntrySequence()
    const animateRobot = setupInteractions()
    const mayStartIntro = setupHomePageTrigger()
    const introStart = { value: null }
    const introDuration = prefersReducedMotion ? 900 : 3400
    const startPosition = camera.position.clone()
    const startTarget = controls.target.clone()

    setupStoryExperience()
    ui.movementButtons.forEach((button) => {
        const direction = button.dataset.move
        const stopMoving = () => setMovementDirection(direction, false)
        button.addEventListener('pointerdown', (event) => {
            event.preventDefault()
            button.setPointerCapture?.(event.pointerId)
            setMovementDirection(direction, true)
            moveCameraByDistance(18)
        })
        button.addEventListener('pointerup', stopMoving)
        button.addEventListener('pointercancel', stopMoving)
        button.addEventListener('lostpointercapture', stopMoving)
        button.addEventListener('contextmenu', (event) => event.preventDefault())
    })
    completeLoading()

    function render(timestamp) {
        requestAnimationFrame(render)

        updateArchitecture(timestamp)
        updateAmbientParticles(timestamp)

        if (introActive && mayStartIntro()) {
            if (introStart.value === null) introStart.value = timestamp
            const progress = Math.min((timestamp - introStart.value) / introDuration, 1)
            const eased = 1 - Math.pow(1 - progress, 3)
            camera.position.lerpVectors(startPosition, chapterViews[0].position, eased)
            controls.target.lerpVectors(startTarget, chapterViews[0].target, eased)
            entrySequence?.update(progress, timestamp)

            if (progress >= 1) {
                introActive = false
                exhibitionRoot.classList.remove('is-entering')
                if (isStandalone) exhibitionRoot.classList.add('is-started')
                controls.enabled = true
                controls.maxPolarAngle = 2.25
                controls.minPolarAngle = 0.9
                controls.minAzimuthAngle = -Infinity
                controls.maxAzimuthAngle = Infinity
                setStatus('可自由探索', 'ready')
                if (isStandalone) {
                    triggerRobotReaction('wave')
                    showToast('RURU 已就位，開始探索吧')
                    showFirstVisitGuide()
                }
            }
        } else if (!introActive) {
            updateCameraTransition(timestamp)
            updateFreeMovement(timestamp)
            animateRobot(timestamp)
            updateHotspots()
        }

        controls.update()
        renderer.render(scene, camera)
    }

    requestAnimationFrame(render)

    window.addEventListener('resize', () => {
        const viewport = exhibitionRoot.getBoundingClientRect()
        const viewportWidth = Math.max(viewport.width, 1)
        const viewportHeight = Math.max(viewport.height, 1)
        camera.aspect = viewportWidth / viewportHeight
        camera.fov = getResponsiveCameraFov(viewportWidth, viewportHeight)
        camera.updateProjectionMatrix()
        renderer.setSize(viewportWidth, viewportHeight, false)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, viewportWidth <= 820 ? 1.35 : 1.65))
        if (experienceStarted && !introActive) setRobotChapterPose(currentChapter, true)
    }, { passive: true })
}

ui.enter?.addEventListener('click', beginExperience)
ui.storyHandle?.addEventListener('click', () => {
    setStorySheetCollapsed(!ui.storyPanel?.classList.contains('is-sheet-collapsed'))
})
ui.storyPanel?.addEventListener('mouseenter', pauseGuidedTour)
ui.storyPanel?.addEventListener('mouseleave', resumeGuidedTour)
ui.robotDialogue?.addEventListener('mouseenter', pauseGuidedTour)
ui.robotDialogue?.addEventListener('mouseleave', resumeGuidedTour)
ui.closeGuide?.addEventListener('click', () => setGuide(false))
ui.help?.addEventListener('click', () => {
    ui.help.classList.add('is-discovered')
    setGuide(ui.guide?.classList.contains('is-closed'))
})
ui.retry?.addEventListener('click', () => window.location.reload())
ui.reset?.addEventListener('click', resetView)
ui.fullscreen?.addEventListener('click', async () => {
    try {
        if (document.fullscreenElement) await document.exitFullscreen()
        else await exhibitionRoot.requestFullscreen()
    } catch (error) {
        showToast('此瀏覽器無法切換全螢幕')
    }
})

document.addEventListener('fullscreenchange', () => {
    const label = ui.fullscreen?.querySelector('span:last-child')
    if (label) label.textContent = document.fullscreenElement ? '離開全螢幕' : '全螢幕'
    if (controls && isHomeExperience) controls.enableZoom = document.fullscreenElement === exhibitionRoot
})

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        setGuide(false)
        setStoryPanelOpen(false)
    }
    if (event.key.toLowerCase() === 'h') setGuide(ui.guide?.classList.contains('is-closed'))
    if (event.key.toLowerCase() === 'r') resetView()
    if (!isStandalone || !experienceStarted || introActive) return
    const movementDirection = movementKeyDirections.get(event.key.toLowerCase())
    if (movementDirection) {
        event.preventDefault()
        setMovementDirection(movementDirection, true)
        if (!event.repeat) moveCameraByDistance(18)
    }
})

document.addEventListener('keyup', (event) => {
    const movementDirection = movementKeyDirections.get(event.key.toLowerCase())
    if (movementDirection) setMovementDirection(movementDirection, false)
})

window.addEventListener('blur', clearMovementDirections)

Promise.all([
    loadModel('exhibit', modelSources.exhibit),
    loadModel('robot', modelSources.robot)
]).then(([loadedExhibit, loadedRobot]) => {
    exhibit = loadedExhibit
    robot = loadedRobot
    startExperience()
}).catch((error) => {
    console.error('Unable to load the virtual exhibition.', error)
    showLoadError()
})